export type Country = {
  countryNameLocal: string;
  countryName?: string;
  countrySynonymsLocal: string;
  countryCode: string;
  currencyCode: string;
  officialLanguageCode: string;
  phoneCode?: string;
  flag?: string;
  postalCode?: { mask: string; placeholder: string; regex: RegExp };
  phoneFormat?: {
    mask: string;
    placeholder: string;
  };
  vatFormat?: {
    mask: string;
    placeholder: string;
    example: string;
    regex: RegExp;
  };
};

const rawCountries = [
  {
    countryNameLocal: 'Andorra',
    countrySynonymsLocal: '',
    countryCode: 'AD',
    currencyCode: 'EUR',
    officialLanguageCode: 'ca',
    phoneCode: '+376',
    flag: '🇦🇩',
    postalCode: { mask: 'aaaa999', placeholder: 'AD500', regex: /^AD\d{3}$/ },
    phoneFormat: {
      mask: '999 999',
      placeholder: '123 456',
      example: '+376 123 456'
    }
  },
  {
    countryNameLocal:
      'د افغانستان اسلامي دولتدولت اسلامی افغانستان, جمهوری اسلامی افغانستان',
    countrySynonymsLocal: '',
    countryCode: 'AF',
    currencyCode: 'AFN',
    officialLanguageCode: 'fa',
    phoneCode: '+93',
    flag: '🇦🇫',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '701 234 567',
      example: '+93 701 234 567'
    }
  },
  {
    countryNameLocal: 'Antigua and Barbuda',
    countrySynonymsLocal: '',
    countryCode: 'AG',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇦🇬',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(268) 123-4567',
      example: '+1 (268) 123-4567'
    }
  },
  {
    countryNameLocal: 'Anguilla',
    countrySynonymsLocal: '',
    countryCode: 'AI',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇦🇮',
    postalCode: { mask: 'aaaa9999', placeholder: 'AI2640', regex: /^AI-2640$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(264) 123-4567',
      example: '+1 (264) 123-4567'
    }
  },
  {
    countryNameLocal: 'Shqipëria',
    countrySynonymsLocal: '',
    countryCode: 'AL',
    currencyCode: 'ALL',
    officialLanguageCode: 'sq',
    phoneCode: '+355',
    flag: '🇦🇱',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '691 234 567',
      example: '+355 691 234 567'
    }
  },
  {
    countryNameLocal: 'Հայաստան',
    countrySynonymsLocal: '',
    countryCode: 'AM',
    currencyCode: 'AMD',
    officialLanguageCode: 'hy',
    phoneCode: '+374',
    flag: '🇦🇲',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '99 999999',
      placeholder: '91 123456',
      example: '+374 91 123456'
    }
  },
  {
    countryNameLocal: 'Angola',
    countrySynonymsLocal: '',
    countryCode: 'AO',
    currencyCode: 'AOA',
    officialLanguageCode: 'pt',
    phoneCode: '+244',
    flag: '🇦🇴',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '923 123 456',
      example: '+244 923 123 456'
    }
  },
  {
    countryNameLocal: 'Antarctica, Antártico, Antarctique, Антарктике',
    countrySynonymsLocal: '',
    countryCode: 'AQ',
    currencyCode: '',
    officialLanguageCode: 'en',
    phoneCode: '+672',
    flag: '🇦🇶',
    phoneFormat: {
      mask: '999 999',
      placeholder: '123 456',
      example: '+672 123 456'
    }
  },
  {
    countryNameLocal: 'Argentina',
    countrySynonymsLocal: '',
    countryCode: 'AR',
    currencyCode: 'ARS',
    officialLanguageCode: 'es',
    phoneCode: '+54',
    flag: '🇦🇷',
    postalCode: {
      mask: 'a9999aaa',
      placeholder: 'C1234ABC',
      regex: /^[A-Z]\d{4}[A-Z]{3}$/
    },
    phoneFormat: {
      mask: '999 9999-9999',
      placeholder: '911 1234-5678',
      example: '+54 911 1234-5678'
    }
  },
  {
    countryNameLocal: 'American Samoa',
    countrySynonymsLocal: '',
    countryCode: 'AS',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇦🇸',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(684) 123-4567',
      example: '+1 (684) 123-4567'
    }
  },
  {
    countryNameLocal: 'Österreich',
    countrySynonymsLocal: '',
    countryCode: 'AT',
    currencyCode: 'EUR',
    officialLanguageCode: 'de',
    countryName: 'Österreich',
    phoneCode: '+43',
    flag: '🇦🇹',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 99999999',
      placeholder: '664 1234567',
      example: '+43 664 1234567',
      regex:
        /^(6[0-9]{2}|65[0-9]|66[0-9]|67[0-9]|68[0-9]|69[0-9]|2[0-9]{2}|3[0-9]{2}|4[0-9]{2}|5[0-9]{2}|7[0-9]{2}|8[0-9]{2}|9[0-9]{2})\s?[0-9]{6,7}$/
    },
    vatFormat: {
      mask: 'aa*99999999',
      placeholder: 'ATU12345678',
      example: 'ATU12345678',
      regex: /^AT[A-Z]\d{8}$/
    }
  },
  {
    countryNameLocal: 'Australia',
    countrySynonymsLocal: '',
    countryCode: 'AU',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    countryName: 'Australien',
    phoneCode: '+61',
    flag: '🇦🇺',
    postalCode: { mask: '9999', placeholder: '2000', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '412 345 678',
      example: '+61 412 345 678'
    },
    vatFormat: {
      mask: '99 999 999 999',
      placeholder: '12 345 678 901',
      example: 'AU12 345 678 901',
      regex: /^\d{2} \d{3} \d{3} \d{3}$/
    }
  },
  {
    countryNameLocal: 'Aruba',
    countrySynonymsLocal: '',
    countryCode: 'AW',
    currencyCode: 'AWG',
    officialLanguageCode: 'nl',
    phoneCode: '+297',
    flag: '🇦🇼',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '560 1234',
      example: '+297 560 1234'
    }
  },
  {
    countryNameLocal: 'Åland',
    countrySynonymsLocal: '',
    countryCode: 'AX',
    currencyCode: 'EUR',
    officialLanguageCode: 'sv',
    phoneCode: '+358',
    flag: '🇦🇽',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '18 1234567',
      example: '+358 18 1234567'
    }
  },
  {
    countryNameLocal: 'Azərbaycan',
    countrySynonymsLocal: '',
    countryCode: 'AZ',
    currencyCode: 'AZN',
    officialLanguageCode: 'az',
    phoneCode: '+994',
    flag: '🇦🇿',
    postalCode: { mask: 'aaaa9999', placeholder: 'AZ1000', regex: /^AZ\d{4}$/ },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '50 123 45 67',
      example: '+994 50 123 45 67'
    }
  },
  {
    countryNameLocal: 'Bosna i Hercegovina',
    countrySynonymsLocal: '',
    countryCode: 'BA',
    currencyCode: 'BAM',
    officialLanguageCode: 'bs',
    phoneCode: '+387',
    flag: '🇧🇦',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '61 123 456',
      example: '+387 61 123 456'
    }
  },
  {
    countryNameLocal: 'Barbados',
    countrySynonymsLocal: '',
    countryCode: 'BB',
    currencyCode: 'BBD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇧🇧',
    postalCode: {
      mask: 'aaaa99999',
      placeholder: 'BB12345',
      regex: /^BB\d{5}$/
    },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(246) 123-4567',
      example: '+1 (246) 123-4567'
    }
  },
  {
    countryNameLocal: 'গণপ্রজাতন্ত্রী বাংলাদেশ',
    countrySynonymsLocal: '',
    countryCode: 'BD',
    currencyCode: 'BDT',
    officialLanguageCode: 'bn',
    phoneCode: '+880',
    flag: '🇧🇩',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '1712 345678',
      example: '+880 1712 345678'
    }
  },
  {
    countryNameLocal: 'België, Belgique, Belgien',
    countrySynonymsLocal: '',
    countryCode: 'BE',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl',
    countryName: 'Belgien',
    phoneCode: '+32',
    flag: '🇧🇪',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 999999',
      placeholder: '496 123456',
      example: '+32 496 123456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '0123456789',
      example: 'BE0123456789',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Burkina Faso',
    countrySynonymsLocal: '',
    countryCode: 'BF',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+226',
    flag: '🇧🇫',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '70 12 34 56',
      example: '+226 70 12 34 56'
    }
  },
  {
    countryNameLocal: 'България',
    countrySynonymsLocal: '',
    countryCode: 'BG',
    currencyCode: 'BGN',
    officialLanguageCode: 'bg',
    countryName: 'Bulgarien',
    phoneCode: '+359',
    flag: '🇧🇬',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '88 1234567',
      example: '+359 88 1234567'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '123456789',
      example: 'BG123456789',
      regex: /^\d{9,10}$/
    }
  },
  {
    countryNameLocal: 'البحرين',
    countrySynonymsLocal: '',
    countryCode: 'BH',
    currencyCode: 'BHD',
    officialLanguageCode: 'ar',
    phoneCode: '+973',
    flag: '🇧🇭',
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '3612 3456',
      example: '+973 3612 3456'
    }
  },
  {
    countryNameLocal: 'Burundi',
    countrySynonymsLocal: '',
    countryCode: 'BI',
    currencyCode: 'BIF',
    officialLanguageCode: 'fr',
    phoneCode: '+257',
    flag: '🇧🇮',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '79 12 34 56',
      example: '+257 79 12 34 56'
    }
  },
  {
    countryNameLocal: 'Bénin',
    countrySynonymsLocal: '',
    countryCode: 'BJ',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+229',
    flag: '🇧🇯',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '90 12 34 56',
      example: '+229 90 12 34 56'
    }
  },
  {
    countryNameLocal: 'Saint-Barthélemy',
    countrySynonymsLocal: '',
    countryCode: 'BL',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+590',
    flag: '🇧🇱',
    postalCode: { mask: '99999', placeholder: '97133', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '690 12 34 56',
      example: '+590 690 12 34 56'
    }
  },
  {
    countryNameLocal: 'Bermuda',
    countrySynonymsLocal: '',
    countryCode: 'BM',
    currencyCode: 'BMD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇧🇲',
    postalCode: {
      mask: 'aa 99',
      placeholder: 'AA 12',
      regex: /^[A-Z]{2} \d{2}$/
    },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(441) 123-4567',
      example: '+1 (441) 123-4567'
    }
  },
  {
    countryNameLocal: 'Brunei Darussalam',
    countrySynonymsLocal: '',
    countryCode: 'BN',
    currencyCode: 'BND',
    officialLanguageCode: 'ms',
    countryName: 'Brunei',
    phoneCode: '+673',
    flag: '🇧🇳',
    postalCode: {
      mask: 'aa9999',
      placeholder: 'AB1234',
      regex: /^[A-Z]{2}\d{4}$/
    },
    phoneFormat: {
      mask: '999 9999',
      placeholder: '712 3456',
      example: '+673 712 3456'
    },
    vatFormat: {
      mask: '99-9999999-999',
      placeholder: '12-3456789-012',
      example: 'BN12-3456789-012',
      regex: /^\d{2}-\d{7}-\d{3}$/
    }
  },
  {
    countryNameLocal: 'Bolivia, Bulibiya, Volívia, Wuliwya',
    countrySynonymsLocal: '',
    countryCode: 'BO',
    currencyCode: 'BOP',
    officialLanguageCode: 'es',
    phoneCode: '+591',
    flag: '🇧🇴',
    phoneFormat: {
      mask: '999 99999',
      placeholder: '712 34567',
      example: '+591 712 34567'
    }
  },
  {
    countryNameLocal: 'Caribisch Nederland',
    countrySynonymsLocal: '',
    countryCode: 'BQ',
    currencyCode: 'USD',
    officialLanguageCode: 'nl',
    phoneCode: '+599',
    flag: '🇧🇶',
    phoneFormat: {
      mask: '9 999 9999',
      placeholder: '9 123 4567',
      example: '+599 9 123 4567'
    }
  },
  {
    countryNameLocal: 'Brasil',
    countrySynonymsLocal: '',
    countryCode: 'BR',
    currencyCode: 'BRL',
    officialLanguageCode: 'pt',
    countryName: 'Brasilien',
    phoneCode: '+55',
    flag: '🇧🇷',
    postalCode: {
      mask: '99999-999',
      placeholder: '12345-678',
      regex: /^\d{5}-\d{3}$/
    },
    phoneFormat: {
      mask: '(99) 99999-9999',
      placeholder: '(11) 91234-5678',
      example: '+55 (11) 91234-5678'
    },
    vatFormat: {
      mask: '99.999.999/9999-99',
      placeholder: '12.345.678/0001-90',
      example: 'BR12.345.678/0001-90',
      regex: /^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/
    }
  },
  {
    countryNameLocal: 'འབྲུག་ཡུལ',
    countrySynonymsLocal: '',
    countryCode: 'BT',
    currencyCode: 'BTN',
    officialLanguageCode: 'dz',
    phoneCode: '+975',
    flag: '🇧🇹',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '171 234 567',
      example: '+975 171 234 567'
    }
  },
  {
    countryNameLocal: 'Bouvetøya',
    countrySynonymsLocal: '',
    countryCode: 'BV',
    currencyCode: 'NOK',
    officialLanguageCode: 'no',
    phoneCode: '+47',
    flag: '🇧🇻',
    phoneFormat: {
      mask: '999 99 999',
      placeholder: '123 45 678',
      example: '+47 123 45 678'
    }
  },
  {
    countryNameLocal: 'Botswana',
    countrySynonymsLocal: '',
    countryCode: 'BW',
    currencyCode: 'BWP',
    officialLanguageCode: 'en',
    phoneCode: '+267',
    flag: '🇧🇼',
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '71 123 456',
      example: '+267 71 123 456'
    }
  },
  {
    countryNameLocal: 'Беларусь',
    countrySynonymsLocal: '',
    countryCode: 'BY',
    currencyCode: 'BYR',
    officialLanguageCode: 'be',
    phoneCode: '+375',
    flag: '🇧🇾',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '(99) 999-99-99',
      placeholder: '(29) 123-45-67',
      example: '+375 (29) 123-45-67'
    }
  },
  {
    countryNameLocal: 'Belize',
    countrySynonymsLocal: '',
    countryCode: 'BZ',
    currencyCode: 'BZD',
    officialLanguageCode: 'en',
    phoneCode: '+501',
    flag: '🇧🇿',
    phoneFormat: {
      mask: '999-9999',
      placeholder: '612-3456',
      example: '+501 612-3456'
    }
  },
  {
    countryNameLocal: 'Canada',
    countrySynonymsLocal: '',
    countryCode: 'CA',
    currencyCode: 'CAD',
    officialLanguageCode: 'en',
    countryName: 'Kanada',
    phoneCode: '+1',
    flag: '🇨🇦',
    postalCode: {
      mask: 'a9a 9a9',
      placeholder: 'G5Y 8J8',
      regex: /^[A-Z]\d[A-Z] \d[A-Z]\d$/
    },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(416) 123-4567',
      example: '+1 (416) 123-4567'
    },
    vatFormat: {
      mask: '999999999**9999',
      placeholder: '123456789RT0001',
      example: 'CA123456789RT0001',
      regex: /^\d{9}(RT|RM|RP)\d{4}$/
    }
  },
  {
    countryNameLocal: 'Schweiz, Suisse, Svizzera, Svizra',
    countrySynonymsLocal: '',
    countryCode: 'CH',
    currencyCode: 'CHE',
    officialLanguageCode: 'de',
    countryName: 'Schweiz',
    phoneCode: '+41',
    flag: '🇨🇭',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '79 123 45 67',
      example: '+41 79 123 45 67'
    },
    vatFormat: {
      mask: '999999',
      placeholder: '123456',
      example: 'CHE-123.456.789 MWST',
      regex: /^\d{6}$/
    }
  },
  {
    countryNameLocal: "Côte d'Ivoire",
    countrySynonymsLocal: '',
    countryCode: 'CI',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+225',
    flag: '🇨🇮',
    phoneFormat: {
      mask: '99 99 99 99 99',
      placeholder: '07 12 34 56 78',
      example: '+225 07 12 34 56 78'
    }
  },
  {
    countryNameLocal: 'Chile',
    countrySynonymsLocal: '',
    countryCode: 'CL',
    currencyCode: 'CLP',
    officialLanguageCode: 'es',
    phoneCode: '+56',
    flag: '🇨🇱',
    postalCode: { mask: '9999999', placeholder: '1234567', regex: /^\d{7}$/ },
    phoneFormat: {
      mask: '9 9999 9999',
      placeholder: '9 1234 5678',
      example: '+56 9 1234 5678'
    }
  },
  {
    countryNameLocal: 'Cameroun, Cameroon',
    countrySynonymsLocal: '',
    countryCode: 'CM',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr',
    phoneCode: '+237',
    flag: '🇨🇲',
    phoneFormat: {
      mask: '9999 99 99 99',
      placeholder: '6712 34 56 78',
      example: '+237 6712 34 56 78'
    }
  },
  {
    countryNameLocal: '中国',
    countrySynonymsLocal: '',
    countryCode: 'CN',
    currencyCode: 'CNY',
    officialLanguageCode: 'zh-hans',
    countryName: 'China',
    phoneCode: '+86',
    flag: '🇨🇳',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 9999 9999',
      placeholder: '138 0013 8000',
      example: '+86 138 0013 8000'
    },
    vatFormat: {
      mask: '999999999999999999',
      placeholder: '123456789012345678',
      example: 'CN123456789012345678',
      regex: /^\d{18}$/
    }
  },
  {
    countryNameLocal: 'Colombia',
    countrySynonymsLocal: '',
    countryCode: 'CO',
    currencyCode: 'COP',
    officialLanguageCode: 'es',
    phoneCode: '+57',
    flag: '🇨🇴',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '321 1234567',
      example: '+57 321 1234567'
    }
  },
  {
    countryNameLocal: 'Costa Rica',
    countrySynonymsLocal: '',
    countryCode: 'CR',
    currencyCode: 'CRC',
    officialLanguageCode: 'es',
    phoneCode: '+506',
    flag: '🇨🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '8312 3456',
      example: '+506 8312 3456'
    }
  },
  {
    countryNameLocal: 'Cuba',
    countrySynonymsLocal: '',
    countryCode: 'CU',
    currencyCode: 'CUC',
    officialLanguageCode: 'es',
    phoneCode: '+53',
    flag: '🇨🇺',
    postalCode: {
      mask: 'aaaa 99999',
      placeholder: 'CP 12345',
      regex: /^CP \d{5}$/
    },
    phoneFormat: {
      mask: '9 999 9999',
      placeholder: '5 123 4567',
      example: '+53 5 123 4567'
    }
  },
  {
    countryNameLocal: 'Cabo Verde',
    countrySynonymsLocal: '',
    countryCode: 'CV',
    currencyCode: 'CVE',
    officialLanguageCode: 'pt',
    phoneCode: '+238',
    flag: '🇨🇻',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 99 99',
      placeholder: '991 23 45',
      example: '+238 991 23 45'
    }
  },
  {
    countryNameLocal: 'Curaçao',
    countrySynonymsLocal: '',
    countryCode: 'CW',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl',
    phoneCode: '+599',
    flag: '🇨🇼',
    phoneFormat: {
      mask: '9 999 9999',
      placeholder: '9 123 4567',
      example: '+599 9 123 4567'
    }
  },
  {
    countryNameLocal: 'Christmas Island',
    countrySynonymsLocal: '',
    countryCode: 'CX',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+61',
    flag: '🇨🇽',
    postalCode: { mask: '9999', placeholder: '6798', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '916 123 456',
      example: '+61 916 123 456'
    }
  },
  {
    countryNameLocal: 'Κύπρος, Kibris',
    countrySynonymsLocal: '',
    countryCode: 'CY',
    currencyCode: 'EUR',
    officialLanguageCode: 'el',
    phoneCode: '+357',
    flag: '🇨🇾',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '99 999999',
      placeholder: '99 123456',
      example: '+357 99 123456'
    }
  },
  {
    countryNameLocal: 'Deutschland',
    countrySynonymsLocal: '',
    countryCode: 'DE',
    currencyCode: 'EUR',
    officialLanguageCode: 'de',
    countryName: 'Deutschland',
    phoneCode: '+49',
    flag: '🇩🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 99999999',
      placeholder: '151 12345678',
      example: '+49 151 12345678'
    },
    vatFormat: {
      mask: 'aa 999999999',
      placeholder: 'DE123456789',
      example: 'DE123456789',
      regex: /^DE\d{9}$/
    }
  },
  {
    countryNameLocal: 'Djibouti, جيبوتي, Jabuuti, Gabuutih',
    countrySynonymsLocal: '',
    countryCode: 'DJ',
    currencyCode: 'DJF',
    officialLanguageCode: 'fr',
    phoneCode: '+253',
    flag: '🇩🇯',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '77 12 34 56',
      example: '+253 77 12 34 56'
    }
  },
  {
    countryNameLocal: 'Danmark',
    countrySynonymsLocal: '',
    countryCode: 'DK',
    currencyCode: 'DKK',
    officialLanguageCode: 'da',
    countryName: 'Dänemark',
    phoneCode: '+45',
    flag: '🇩🇰',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '20 12 34 56',
      example: '+45 20 12 34 56'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'DK12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Dominica',
    countrySynonymsLocal: '',
    countryCode: 'DM',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇩🇲',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(767) 123-4567',
      example: '+1 (767) 123-4567'
    }
  },
  {
    countryNameLocal: 'الجزائر',
    countrySynonymsLocal: '',
    countryCode: 'DZ',
    currencyCode: 'DZD',
    officialLanguageCode: 'ar',
    phoneCode: '+213',
    flag: '🇩🇿',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '551 23 45 67',
      example: '+213 551 23 45 67'
    }
  },
  {
    countryNameLocal: 'Ecuador',
    countrySynonymsLocal: '',
    countryCode: 'EC',
    currencyCode: 'USD',
    officialLanguageCode: 'es',
    phoneCode: '+593',
    flag: '🇪🇨',
    postalCode: {
      mask: 'aaaa999999',
      placeholder: 'EC170150',
      regex: /^EC\d{6}$/
    },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '991 234 567',
      example: '+593 991 234 567'
    }
  },
  {
    countryNameLocal: 'Eesti',
    countrySynonymsLocal: '',
    countryCode: 'EE',
    currencyCode: 'EUR',
    officialLanguageCode: 'et',
    countryName: 'Estland',
    phoneCode: '+372',
    flag: '🇪🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5123 4567',
      example: '+372 5123 4567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'EE123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'مصر',
    countrySynonymsLocal: '',
    countryCode: 'EG',
    currencyCode: 'EGP',
    officialLanguageCode: 'ar',
    phoneCode: '+20',
    flag: '🇪🇬',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 999 9999',
      placeholder: '1000 123 4567',
      example: '+20 1000 123 4567'
    }
  },
  {
    countryNameLocal: 'Sahara Occidental',
    countrySynonymsLocal: '',
    countryCode: 'EH',
    currencyCode: 'MAD',
    officialLanguageCode: 'ar',
    phoneCode: '+212',
    flag: '🇪🇭',
    phoneFormat: {
      mask: '9999 99 99 99',
      placeholder: '6123 45 67 89',
      example: '+212 6123 45 67 89'
    }
  },
  {
    countryNameLocal: 'ኤርትራ, إرتريا, Eritrea',
    countrySynonymsLocal: '',
    countryCode: 'ER',
    currencyCode: 'ERN',
    officialLanguageCode: 'ti',
    phoneCode: '+291',
    flag: '🇪🇷',
    phoneFormat: {
      mask: '9 999 999',
      placeholder: '7 123 456',
      example: '+291 7 123 456'
    }
  },
  {
    countryNameLocal: 'España',
    countrySynonymsLocal: '',
    countryCode: 'ES',
    currencyCode: 'EUR',
    officialLanguageCode: 'es',
    countryName: 'Spanien',
    phoneCode: '+34',
    flag: '🇪🇸',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '612 345 678',
      example: '+34 612 345 678'
    },
    vatFormat: {
      mask: '*99999999*',
      placeholder: 'A12345674',
      example: 'ESA12345674',
      regex: /^[A-Z]\d{7}[A-Z0-9]$/
    }
  },
  {
    countryNameLocal: 'ኢትዮጵያ, Itoophiyaa',
    countrySynonymsLocal: '',
    countryCode: 'ET',
    currencyCode: 'ETB',
    officialLanguageCode: 'am',
    phoneCode: '+251',
    flag: '🇪🇹',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '911 123 456',
      example: '+251 911 123 456'
    }
  },
  {
    countryNameLocal: 'Suomi',
    countrySynonymsLocal: '',
    countryCode: 'FI',
    currencyCode: 'EUR',
    officialLanguageCode: 'fi',
    countryName: 'Finnland',
    phoneCode: '+358',
    flag: '🇫🇮',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '40 1234567',
      example: '+358 40 1234567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'FI12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Fiji',
    countrySynonymsLocal: '',
    countryCode: 'FJ',
    currencyCode: 'FJD',
    officialLanguageCode: 'en',
    phoneCode: '+679',
    flag: '🇫🇯',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '701 2345',
      example: '+679 701 2345'
    }
  },
  {
    countryNameLocal: 'Micronesia',
    countrySynonymsLocal: '',
    countryCode: 'FM',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+691',
    flag: '🇫🇲',
    postalCode: { mask: '99999', placeholder: '96941', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 9999',
      placeholder: '350 1234',
      example: '+691 350 1234'
    }
  },
  {
    countryNameLocal: 'France',
    countrySynonymsLocal: '',
    countryCode: 'FR',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    countryName: 'Frankreich',
    phoneCode: '+33',
    flag: '🇫🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '9 99 99 99 99',
      placeholder: '6 12 34 56 78',
      example: '+33 6 12 34 56 78'
    },
    vatFormat: {
      mask: '*99999999999',
      placeholder: 'FR12345678901',
      example: 'FR12345678901',
      regex: /^FR[A-Z0-9]{2}\d{9}$/
    }
  },
  {
    countryNameLocal: 'Gabon',
    countrySynonymsLocal: '',
    countryCode: 'GA',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr',
    phoneCode: '+241',
    flag: '🇬🇦',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '06 12 34 56',
      example: '+241 06 12 34 56'
    }
  },
  {
    countryNameLocal: 'Grenada',
    countrySynonymsLocal: '',
    countryCode: 'GD',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇬🇩',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(473) 123-4567',
      example: '+1 (473) 123-4567'
    }
  },
  {
    countryNameLocal: 'საქართველო',
    countrySynonymsLocal: '',
    countryCode: 'GE',
    currencyCode: 'GEL',
    officialLanguageCode: 'ka',
    phoneCode: '+995',
    flag: '🇬🇪',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '555 12 34 56',
      example: '+995 555 12 34 56'
    }
  },
  {
    countryNameLocal: 'Guyane française',
    countrySynonymsLocal: '',
    countryCode: 'GF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+594',
    flag: '🇬🇫',
    postalCode: { mask: '99999', placeholder: '97300', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '694 12 34 56',
      example: '+594 694 12 34 56'
    }
  },
  {
    countryNameLocal: 'Guernsey',
    countrySynonymsLocal: '',
    countryCode: 'GG',
    currencyCode: 'GBP',
    officialLanguageCode: 'en',
    phoneCode: '+44',
    flag: '🇬🇬',
    postalCode: {
      mask: 'aa99 9aa',
      placeholder: 'GY1 2AB',
      regex: /^GY\d{1,2} \d[A-Z]{2}$/
    },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '1481 123456',
      example: '+44 1481 123456'
    }
  },
  {
    countryNameLocal: 'Ghana',
    countrySynonymsLocal: '',
    countryCode: 'GH',
    currencyCode: 'GHS',
    officialLanguageCode: 'en',
    phoneCode: '+233',
    flag: '🇬🇭',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '241 234 567',
      example: '+233 241 234 567'
    }
  },
  {
    countryNameLocal: 'Gibraltar',
    countrySynonymsLocal: '',
    countryCode: 'GI',
    currencyCode: 'GIP',
    officialLanguageCode: 'en',
    phoneCode: '+350',
    flag: '🇬🇮',
    postalCode: {
      mask: 'aaaa 99',
      placeholder: 'GX11 1AA',
      regex: /^GX11 1AA$/
    },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '2001 2345',
      example: '+350 2001 2345'
    }
  },
  {
    countryNameLocal: 'Kalaallit Nunaat, Grønland',
    countrySynonymsLocal: '',
    countryCode: 'GL',
    currencyCode: 'DKK',
    officialLanguageCode: 'kl',
    phoneCode: '+299',
    flag: '🇬🇱',
    postalCode: { mask: '9999', placeholder: '3900', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '99 99 99',
      placeholder: '12 34 56',
      example: '+299 12 34 56'
    }
  },
  {
    countryNameLocal: 'Guinée',
    countrySynonymsLocal: '',
    countryCode: 'GN',
    currencyCode: 'GNF',
    officialLanguageCode: 'fr',
    phoneCode: '+224',
    flag: '🇬🇳',
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '601 12 34 56',
      example: '+224 601 12 34 56'
    }
  },
  {
    countryNameLocal: 'Guadeloupe',
    countrySynonymsLocal: '',
    countryCode: 'GP',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+590',
    flag: '🇬🇵',
    postalCode: { mask: '99999', placeholder: '97100', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '690 12 34 56',
      example: '+590 690 12 34 56'
    }
  },
  {
    countryNameLocal: 'Guiena ecuatorial, Guinée équatoriale, Guiné Equatorial',
    countrySynonymsLocal: '',
    countryCode: 'GQ',
    currencyCode: 'XAF',
    officialLanguageCode: 'es',
    phoneCode: '+240',
    flag: '🇬🇶',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '222 123 456',
      example: '+240 222 123 456'
    }
  },
  {
    countryNameLocal: 'Ελλάδα',
    countrySynonymsLocal: '',
    countryCode: 'GR',
    currencyCode: 'EUR',
    officialLanguageCode: 'el',
    countryName: 'Griechenland',
    phoneCode: '+30',
    flag: '🇬🇷',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '694 1234567',
      example: '+30 694 1234567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'EL123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'South Georgia and the South Sandwich Islands',
    countrySynonymsLocal: '',
    countryCode: 'GS',
    currencyCode: '',
    officialLanguageCode: 'en',
    phoneCode: '+500',
    flag: '🇬🇸',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+500 12345'
    }
  },
  {
    countryNameLocal: 'Guatemala',
    countrySynonymsLocal: '',
    countryCode: 'GT',
    currencyCode: 'GTQ',
    officialLanguageCode: 'es',
    phoneCode: '+502',
    flag: '🇬🇹',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5123 4567',
      example: '+502 5123 4567'
    }
  },
  {
    countryNameLocal: 'Guam, Guåhån',
    countrySynonymsLocal: '',
    countryCode: 'GU',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇬🇺',
    postalCode: { mask: '99999', placeholder: '96910', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(671) 123-4567',
      example: '+1 (671) 123-4567'
    }
  },
  {
    countryNameLocal: 'Guiné-Bissau',
    countrySynonymsLocal: '',
    countryCode: 'GW',
    currencyCode: 'XOF',
    officialLanguageCode: 'pt',
    phoneCode: '+245',
    flag: '🇬🇼',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '955 123 456',
      example: '+245 955 123 456'
    }
  },
  {
    countryNameLocal: 'Guyana',
    countrySynonymsLocal: '',
    countryCode: 'GY',
    currencyCode: 'GYD',
    officialLanguageCode: 'en',
    phoneCode: '+592',
    flag: '🇬🇾',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '612 3456',
      example: '+592 612 3456'
    }
  },
  {
    countryNameLocal: '香港, Hong Kong',
    countrySynonymsLocal: '',
    countryCode: 'HK',
    currencyCode: 'HKD',
    officialLanguageCode: 'zh-hant',
    phoneCode: '+852',
    flag: '🇭🇰',
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9123 4567',
      example: '+852 9123 4567'
    }
  },
  {
    countryNameLocal: 'Honduras',
    countrySynonymsLocal: '',
    countryCode: 'HN',
    currencyCode: 'HNL',
    officialLanguageCode: 'es',
    countryName: 'Honduras',
    phoneCode: '+504',
    flag: '🇭🇳',
    postalCode: {
      mask: 'aa9999',
      placeholder: 'AB1234',
      regex: /^[A-Z]{2}\d{4}$/
    },
    phoneFormat: {
      mask: '9999-9999',
      placeholder: '9123-4567',
      example: '+504 9123-4567'
    },
    vatFormat: {
      mask: '99999999999999',
      placeholder: '12345678901234',
      example: 'HN12345678901234',
      regex: /^\d{14}$/
    }
  },
  {
    countryNameLocal: 'Hrvatska',
    countrySynonymsLocal: '',
    countryCode: 'HR',
    currencyCode: 'HRK',
    officialLanguageCode: 'hr',
    countryName: 'Kroatien',
    phoneCode: '+385',
    flag: '🇭🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '91 1234567',
      example: '+385 91 1234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'HR12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'Haïti, Ayiti',
    countrySynonymsLocal: '',
    countryCode: 'HT',
    currencyCode: 'HTG',
    officialLanguageCode: 'fr',
    phoneCode: '+509',
    flag: '🇭🇹',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '3412 3456',
      example: '+509 3412 3456'
    }
  },
  {
    countryNameLocal: 'Magyarország',
    countrySynonymsLocal: '',
    countryCode: 'HU',
    currencyCode: 'HUF',
    officialLanguageCode: 'hu',
    countryName: 'Ungarn',
    phoneCode: '+36',
    flag: '🇭🇺',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '20 1234567',
      example: '+36 20 1234567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'HU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Indonesia',
    countrySynonymsLocal: '',
    countryCode: 'ID',
    currencyCode: 'IDR',
    officialLanguageCode: 'id',
    countryName: 'Indonesien',
    phoneCode: '+62',
    flag: '🇮🇩',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999-9999-9999',
      placeholder: '812-3456-7890',
      example: '+62 812-3456-7890'
    },
    vatFormat: {
      mask: '999.999.999-999.999',
      placeholder: '123.456.789-012.345',
      example: 'ID123.456.789-012.345',
      regex: /^\d{3}\.\d{3}\.\d{3}-\d{3}\.\d{3}$/
    }
  },
  {
    countryNameLocal: 'Ireland, Éire',
    countrySynonymsLocal: '',
    countryCode: 'IE',
    currencyCode: 'EUR',
    officialLanguageCode: 'en',
    countryName: 'Irland',
    phoneCode: '+353',
    flag: '🇮🇪',
    postalCode: {
      mask: '*99 ****',
      placeholder: 'D02 AF30',
      regex: /^[A-Z0-9]{3} [A-Z0-9]{4}$/
    },
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '85 123 4567',
      example: '+353 85 123 4567'
    },
    vatFormat: {
      mask: '9999999**',
      placeholder: '1234567AB',
      example: 'IE1234567AB / IE8Y25100S',
      regex: /^(\d{7}[A-Z]{1,2})|(\d[A-Z*+]\d{5}[A-Z])$/
    }
  },
  {
    countryNameLocal: 'ישראל',
    countrySynonymsLocal: '',
    countryCode: 'IL',
    currencyCode: 'ILS',
    officialLanguageCode: 'he',
    phoneCode: '+972',
    flag: '🇮🇱',
    postalCode: { mask: '9999999', placeholder: '1234567', regex: /^\d{7}$/ },
    phoneFormat: {
      mask: '999-999-9999',
      placeholder: '50-123-4567',
      example: '+972 50-123-4567'
    }
  },
  {
    countryNameLocal: 'Isle of Man',
    countrySynonymsLocal: '',
    countryCode: 'IM',
    currencyCode: 'GBP',
    officialLanguageCode: 'en',
    phoneCode: '+44',
    flag: '🇮🇲',
    postalCode: {
      mask: 'aa99 9aa',
      placeholder: 'IM1 2AB',
      regex: /^IM\d{1,2} \d[A-Z]{2}$/
    },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '1624 123456',
      example: '+44 1624 123456'
    }
  },
  {
    countryNameLocal: 'भारत, India',
    countrySynonymsLocal: '',
    countryCode: 'IN',
    currencyCode: 'INR',
    officialLanguageCode: 'hi',
    countryName: 'Indien',
    phoneCode: '+91',
    flag: '🇮🇳',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '99999 99999',
      placeholder: '98765 43210',
      example: '+91 98765 43210'
    },
    vatFormat: {
      mask: '99aaaaaa999a9aa',
      placeholder: '12ABCDE3456F1Z5',
      example: 'IN12ABCDE3456F1Z5',
      regex: /^\d{2}[A-Z]{5}\d{4}[A-Z][A-Z0-9][Z][A-Z0-9]$/
    }
  },
  {
    countryNameLocal: 'British Indian Ocean Territories',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+246',
    flag: '🇮🇴',
    postalCode: {
      mask: 'aaaa 1zz',
      placeholder: 'BBND 1ZZ',
      regex: /^BBND 1ZZ$/
    },
    phoneFormat: {
      mask: '999 9999',
      placeholder: '370 1234',
      example: '+246 370 1234'
    }
  },
  {
    countryNameLocal: 'العراق, Iraq',
    countrySynonymsLocal: '',
    countryCode: 'IQ',
    currencyCode: 'IQD',
    officialLanguageCode: 'ar',
    phoneCode: '+964',
    flag: '🇮🇶',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '790 123 4567',
      example: '+964 790 123 4567'
    }
  },
  {
    countryNameLocal: 'ایران',
    countrySynonymsLocal: '',
    countryCode: 'IR',
    currencyCode: 'IRR',
    officialLanguageCode: 'fa',
    phoneCode: '+98',
    flag: '🇮🇷',
    postalCode: {
      mask: '99999-99999',
      placeholder: '12345-67890',
      regex: /^\d{5}-\d{5}$/
    },
    phoneFormat: {
      mask: '9999 999 9999',
      placeholder: '9123 456 7890',
      example: '+98 9123 456 7890'
    }
  },
  {
    countryNameLocal: 'Ísland',
    countrySynonymsLocal: '',
    countryCode: 'IS',
    currencyCode: 'ISK',
    officialLanguageCode: 'is',
    phoneCode: '+354',
    flag: '🇮🇸',
    postalCode: { mask: '999', placeholder: '123', regex: /^\d{3}$/ },
    phoneFormat: {
      mask: '999 9999',
      placeholder: '661 2345',
      example: '+354 661 2345'
    }
  },
  {
    countryNameLocal: 'Italia',
    countrySynonymsLocal: '',
    countryCode: 'IT',
    currencyCode: 'EUR',
    officialLanguageCode: 'it',
    countryName: 'Italien',
    phoneCode: '+39',
    flag: '🇮🇹',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '333 1234567',
      example: '+39 333 1234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'IT12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'Jersey',
    countrySynonymsLocal: '',
    countryCode: 'JE',
    currencyCode: 'GBP',
    officialLanguageCode: 'en',
    phoneCode: '+44',
    flag: '🇯🇪',
    postalCode: {
      mask: 'aa99 9aa',
      placeholder: 'JE1 2AB',
      regex: /^JE\d{1,2} \d[A-Z]{2}$/
    },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '1534 123456',
      example: '+44 1534 123456'
    }
  },
  {
    countryNameLocal: 'Jamaica',
    countrySynonymsLocal: '',
    countryCode: 'JM',
    currencyCode: 'JMD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇯🇲',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(876) 123-4567',
      example: '+1 (876) 123-4567'
    }
  },
  {
    countryNameLocal: 'الأُرْدُن',
    countrySynonymsLocal: '',
    countryCode: 'JO',
    currencyCode: 'JOD',
    officialLanguageCode: 'ar',
    phoneCode: '+962',
    flag: '🇯🇴',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9 9999 9999',
      placeholder: '7 9123 4567',
      example: '+962 7 9123 4567'
    }
  },
  {
    countryNameLocal: '日本',
    countrySynonymsLocal: '',
    countryCode: 'JP',
    currencyCode: 'JPY',
    officialLanguageCode: 'ja',
    countryName: 'Japan',
    phoneCode: '+81',
    flag: '🇯🇵',
    postalCode: {
      mask: '999-9999',
      placeholder: '105-0002',
      regex: /^\d{3}-\d{4}$/
    },
    phoneFormat: {
      mask: '99-9999-9999',
      placeholder: '90-1234-5678',
      example: '+81 90-1234-5678'
    },
    vatFormat: {
      mask: '9999999999999',
      placeholder: '1234567890123',
      example: 'JP1234567890123',
      regex: /^\d{13}$/
    }
  },
  {
    countryNameLocal: 'Kenya',
    countrySynonymsLocal: '',
    countryCode: 'KE',
    currencyCode: 'KES',
    officialLanguageCode: 'sw',
    phoneCode: '+254',
    flag: '🇰🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999999',
      placeholder: '712 123456',
      example: '+254 712 123456'
    }
  },
  {
    countryNameLocal: 'Кыргызстан, Киргизия',
    countrySynonymsLocal: '',
    countryCode: 'KG',
    currencyCode: 'KGS',
    officialLanguageCode: 'ky',
    phoneCode: '+996',
    flag: '🇰🇬',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '555 123 456',
      example: '+996 555 123 456'
    }
  },
  {
    countryNameLocal: 'កម្ពុជា',
    countrySynonymsLocal: '',
    countryCode: 'KH',
    currencyCode: 'KHR',
    officialLanguageCode: 'km',
    phoneCode: '+855',
    flag: '🇰🇭',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '912 345 678',
      example: '+855 912 345 678'
    }
  },
  {
    countryNameLocal: '대한민국',
    countrySynonymsLocal: '',
    countryCode: 'KR',
    currencyCode: 'KRW',
    officialLanguageCode: 'ko',
    countryName: 'Korea',
    phoneCode: '+82',
    flag: '🇰🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99-9999-9999',
      placeholder: '10-1234-5678',
      example: '+82 10-1234-5678'
    },
    vatFormat: {
      mask: '999-99-99999',
      placeholder: '123-45-67890',
      example: 'KR123-45-67890',
      regex: /^\d{3}-\d{2}-\d{5}$/
    }
  },
  {
    countryNameLocal: 'Kiribati',
    countrySynonymsLocal: '',
    countryCode: 'KI',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+686',
    flag: '🇰🇮',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+686 12345'
    }
  },
  {
    countryNameLocal: 'Saint Kitts and Nevis',
    countrySynonymsLocal: '',
    countryCode: 'KN',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇰🇳',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(869) 123-4567',
      example: '+1 (869) 123-4567'
    }
  },
  {
    countryNameLocal: 'الكويت',
    countrySynonymsLocal: '',
    countryCode: 'KW',
    currencyCode: 'KWD',
    officialLanguageCode: 'ar',
    phoneCode: '+965',
    flag: '🇰🇼',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5012 3456',
      example: '+965 5012 3456'
    }
  },
  {
    countryNameLocal: 'Қазақстан, Казахстан',
    countrySynonymsLocal: '',
    countryCode: 'KZ',
    currencyCode: 'KZT',
    officialLanguageCode: 'kk',
    phoneCode: '+7',
    flag: '🇰🇿',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 999 99 99',
      placeholder: '701 234 56 78',
      example: '+7 701 234 56 78'
    }
  },
  {
    countryNameLocal: 'لبنان, Liban',
    countrySynonymsLocal: '',
    countryCode: 'LB',
    currencyCode: 'LBP',
    officialLanguageCode: 'ar',
    phoneCode: '+961',
    flag: '🇱🇧',
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '3 123 456',
      example: '+961 3 123 456'
    }
  },
  {
    countryNameLocal: 'Saint Lucia',
    countrySynonymsLocal: '',
    countryCode: 'LC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇱🇨',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(758) 123-4567',
      example: '+1 (758) 123-4567'
    }
  },
  {
    countryNameLocal: 'Liechtenstein',
    countrySynonymsLocal: '',
    countryCode: 'LI',
    currencyCode: 'CHF',
    officialLanguageCode: 'de',
    phoneCode: '+423',
    flag: '🇱🇮',
    postalCode: { mask: '9999', placeholder: '9490', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 99 99',
      placeholder: '791 23 45',
      example: '+423 791 23 45'
    }
  },
  {
    countryNameLocal: 'ශ්‍රී ලංකා, இலங்கை',
    countrySynonymsLocal: '',
    countryCode: 'LK',
    currencyCode: 'LKR',
    officialLanguageCode: 'si',
    phoneCode: '+94',
    flag: '🇱🇰',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '71 234 5678',
      example: '+94 71 234 5678'
    }
  },
  {
    countryNameLocal: 'Liberia',
    countrySynonymsLocal: '',
    countryCode: 'LR',
    currencyCode: 'LRD',
    officialLanguageCode: 'en',
    phoneCode: '+231',
    flag: '🇱🇷',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '770 123 456',
      example: '+231 770 123 456'
    }
  },
  {
    countryNameLocal: 'Lesotho',
    countrySynonymsLocal: '',
    countryCode: 'LS',
    currencyCode: 'LSL',
    officialLanguageCode: 'en',
    phoneCode: '+266',
    flag: '🇱🇸',
    postalCode: { mask: '999', placeholder: '123', regex: /^\d{3}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5012 3456',
      example: '+266 5012 3456'
    }
  },
  {
    countryNameLocal: 'Lietuva',
    countrySynonymsLocal: '',
    countryCode: 'LT',
    currencyCode: 'EUR',
    officialLanguageCode: 'lt',
    countryName: 'Litauen',
    phoneCode: '+370',
    flag: '🇱🇹',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^(\d{5})$/ },
    phoneFormat: {
      mask: '999 99999',
      placeholder: '612 34567',
      example: '+370 612 34567'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789',
      example: 'LT123456789',
      regex: /^\d{9}|\d{12}$/
    }
  },
  {
    countryNameLocal: 'Lëtzebuerg, Luxembourg, Luxemburg',
    countrySynonymsLocal: '',
    countryCode: 'LU',
    currencyCode: 'EUR',
    officialLanguageCode: 'lb',
    countryName: 'Luxemburg',
    phoneCode: '+352',
    flag: '🇱🇺',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '691 123 456',
      example: '+352 691 123 456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'LU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Latvija',
    countrySynonymsLocal: '',
    countryCode: 'LV',
    currencyCode: 'EUR',
    officialLanguageCode: 'lv',
    countryName: 'Lettland',
    phoneCode: '+371',
    flag: '🇱🇻',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99999999',
      placeholder: '21234567',
      example: '+371 21234567'
    },
    vatFormat: {
      mask: '99999999999',
      placeholder: '12345678901',
      example: 'LV12345678901',
      regex: /^\d{11}$/
    }
  },
  {
    countryNameLocal: 'ليبيا',
    countrySynonymsLocal: '',
    countryCode: 'LY',
    currencyCode: 'LYD',
    officialLanguageCode: 'ar',
    phoneCode: '+218',
    flag: '🇱🇾',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '912 345 678',
      example: '+218 912 345 678'
    }
  },
  {
    countryNameLocal: 'Maroc, ⵍⵎⵖⵔⵉⴱ, المغرب',
    countrySynonymsLocal: '',
    countryCode: 'MA',
    currencyCode: 'MAD',
    officialLanguageCode: 'fr',
    phoneCode: '+212',
    flag: '🇲🇦',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 99 99 99',
      placeholder: '6123 45 67 89',
      example: '+212 6123 45 67 89'
    }
  },
  {
    countryNameLocal: 'Monaco',
    countrySynonymsLocal: '',
    countryCode: 'MC',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+377',
    flag: '🇲🇨',
    postalCode: { mask: '99999', placeholder: '98000', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '6 12 34 56',
      example: '+377 6 12 34 56'
    }
  },
  {
    countryNameLocal: 'Crna Gora, Црна Гора',
    countrySynonymsLocal: '',
    countryCode: 'ME',
    currencyCode: 'EUR',
    officialLanguageCode: 'srp',
    phoneCode: '+382',
    flag: '🇲🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '67 123 456',
      example: '+382 67 123 456'
    }
  },
  {
    countryNameLocal: 'Saint-Martin',
    countrySynonymsLocal: '',
    countryCode: 'MF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+590',
    flag: '🇲🇫',
    postalCode: { mask: '99999', placeholder: '97150', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '690 12 34 56',
      example: '+590 690 12 34 56'
    }
  },
  {
    countryNameLocal: 'Madagasikara, Madagascar',
    countrySynonymsLocal: '',
    countryCode: 'MG',
    currencyCode: 'MGA',
    officialLanguageCode: 'mg',
    phoneCode: '+261',
    flag: '🇲🇬',
    postalCode: { mask: '999', placeholder: '123', regex: /^\d{3}$/ },
    phoneFormat: {
      mask: '99 99 999 99',
      placeholder: '32 12 345 67',
      example: '+261 32 12 345 67'
    }
  },
  {
    countryNameLocal: 'Mali',
    countrySynonymsLocal: '',
    countryCode: 'ML',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+223',
    flag: '🇲🇱',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '70 12 34 56',
      example: '+223 70 12 34 56'
    }
  },
  {
    countryNameLocal: 'မြန်မာ',
    countrySynonymsLocal: '',
    countryCode: 'MM',
    currencyCode: 'MMK',
    officialLanguageCode: 'my',
    phoneCode: '+95',
    flag: '🇲🇲',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9 999 999 999',
      placeholder: '9 123 456 789',
      example: '+95 9 123 456 789'
    }
  },
  {
    countryNameLocal: 'Монгол Улс',
    countrySynonymsLocal: '',
    countryCode: 'MN',
    currencyCode: 'MNT',
    officialLanguageCode: 'mn',
    phoneCode: '+976',
    flag: '🇲🇳',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9912 3456',
      example: '+976 9912 3456'
    }
  },
  {
    countryNameLocal: '澳門, Macau',
    countrySynonymsLocal: '',
    countryCode: 'MO',
    currencyCode: 'MOP',
    officialLanguageCode: 'zh-hant',
    phoneCode: '+853',
    flag: '🇲🇴',
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '6612 3456',
      example: '+853 6612 3456'
    }
  },
  {
    countryNameLocal: 'Martinique',
    countrySynonymsLocal: '',
    countryCode: 'MQ',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+596',
    flag: '🇲🇶',
    postalCode: { mask: '99999', placeholder: '97200', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '696 12 34 56',
      example: '+596 696 12 34 56'
    }
  },
  {
    countryNameLocal: 'موريتانيا, Mauritanie',
    countrySynonymsLocal: '',
    countryCode: 'MR',
    currencyCode: 'MRU',
    officialLanguageCode: 'ar',
    phoneCode: '+222',
    flag: '🇲🇷',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '22 12 34 56',
      example: '+222 22 12 34 56'
    }
  },
  {
    countryNameLocal: 'Montserrat',
    countrySynonymsLocal: '',
    countryCode: 'MS',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇲🇸',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(664) 123-4567',
      example: '+1 (664) 123-4567'
    }
  },
  {
    countryNameLocal: 'Malta',
    countrySynonymsLocal: '',
    countryCode: 'MT',
    currencyCode: 'EUR',
    officialLanguageCode: 'mt',
    countryName: 'Malta',
    phoneCode: '+356',
    flag: '🇲🇹',
    postalCode: {
      mask: 'aaa 9999',
      placeholder: 'ABC 1234',
      regex: /^[A-Z]{3} [0-9]{4}$/
    },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9912 3456',
      example: '+356 9912 3456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'MT12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Maurice, Mauritius',
    countrySynonymsLocal: '',
    countryCode: 'MU',
    currencyCode: 'MUR',
    officialLanguageCode: 'mfe',
    countryName: 'Mauritius',
    phoneCode: '+230',
    flag: '🇲🇺',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '5123 4567',
      example: '+230 5123 4567'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'MU12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MV',
    currencyCode: 'MVR',
    officialLanguageCode: 'dv',
    phoneCode: '+960',
    flag: '🇲🇻',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999-9999',
      placeholder: '791-2345',
      example: '+960 791-2345'
    }
  },
  {
    countryNameLocal: 'Malawi',
    countrySynonymsLocal: '',
    countryCode: 'MW',
    currencyCode: 'MWK',
    officialLanguageCode: 'en',
    phoneCode: '+265',
    flag: '🇲🇼',
    phoneFormat: {
      mask: '9999 99 99 99',
      placeholder: '9912 34 56 78',
      example: '+265 9912 34 56 78'
    }
  },
  {
    countryNameLocal: 'México',
    countrySynonymsLocal: '',
    countryCode: 'MX',
    currencyCode: 'MXN',
    officialLanguageCode: 'es',
    phoneCode: '+52',
    flag: '🇲🇽',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '551 234 5678',
      example: '+52 551 234 5678'
    }
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'MY',
    currencyCode: 'MYR',
    officialLanguageCode: 'ms',
    countryName: 'Malaysia',
    phoneCode: '+60',
    flag: '🇲🇾',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99-999 9999',
      placeholder: '12-345 6789',
      example: '+60 12-345 6789'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789012',
      example: 'MY123456789012',
      regex: /^\d{12}$/
    }
  },
  {
    countryNameLocal: 'Mozambique',
    countrySynonymsLocal: '',
    countryCode: 'MZ',
    currencyCode: 'MZN',
    officialLanguageCode: 'pt',
    phoneCode: '+258',
    flag: '🇲🇿',
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '82 123 4567',
      example: '+258 82 123 4567'
    }
  },
  {
    countryNameLocal: 'Namibia',
    countrySynonymsLocal: '',
    countryCode: 'NA',
    currencyCode: 'NAD',
    officialLanguageCode: 'en',
    phoneCode: '+264',
    flag: '🇳🇦',
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '81 123 4567',
      example: '+264 81 123 4567'
    }
  },
  {
    countryNameLocal: 'Nouvelle-Calédonie',
    countrySynonymsLocal: '',
    countryCode: 'NC',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr',
    phoneCode: '+687',
    flag: '🇳🇨',
    postalCode: { mask: '99999', placeholder: '98800', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99.99.99',
      placeholder: '75.12.34',
      example: '+687 75.12.34'
    }
  },
  {
    countryNameLocal: 'Norfolk Island',
    countrySynonymsLocal: '',
    countryCode: 'NF',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+672',
    flag: '🇳🇫',
    postalCode: { mask: '9999', placeholder: '2899', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999',
      placeholder: '3 12345',
      example: '+672 3 12345'
    }
  },
  {
    countryNameLocal: 'Nigeria',
    countrySynonymsLocal: '',
    countryCode: 'NG',
    currencyCode: 'NGN',
    officialLanguageCode: 'en',
    phoneCode: '+234',
    flag: '🇳🇬',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '802 123 4567',
      example: '+234 802 123 4567'
    }
  },
  {
    countryNameLocal: 'Nicaragua',
    countrySynonymsLocal: '',
    countryCode: 'NI',
    currencyCode: 'NIO',
    officialLanguageCode: 'es',
    countryName: 'Nicaragua',
    phoneCode: '+505',
    flag: '🇳🇮',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '8123 4567',
      example: '+505 8123 4567'
    },
    vatFormat: {
      mask: '9999999999999999',
      placeholder: '1234567890123456',
      example: 'NI1234567890123456',
      regex: /^\d{16}$/
    }
  },
  {
    countryNameLocal: 'Norge, Noreg',
    countrySynonymsLocal: '',
    countryCode: 'NO',
    currencyCode: 'NOK',
    officialLanguageCode: 'nb',
    phoneCode: '+47',
    flag: '🇳🇴',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 99 999',
      placeholder: '412 34 567',
      example: '+47 412 34 567'
    }
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'NP',
    currencyCode: 'NPR',
    officialLanguageCode: 'ne',
    phoneCode: '+977',
    flag: '🇳🇵',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999-9999999',
      placeholder: '984-1234567',
      example: '+977 984-1234567'
    }
  },
  {
    countryNameLocal: 'Nauru',
    countrySynonymsLocal: '',
    countryCode: 'NR',
    currencyCode: 'AUD',
    officialLanguageCode: 'na',
    phoneCode: '+674',
    flag: '🇳🇷',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '555 1234',
      example: '+674 555 1234'
    }
  },
  {
    countryNameLocal: 'Niue',
    countrySynonymsLocal: '',
    countryCode: 'NU',
    currencyCode: 'NZD',
    officialLanguageCode: 'niu',
    phoneCode: '+683',
    flag: '🇳🇺',
    phoneFormat: {
      mask: '9999',
      placeholder: '1234',
      example: '+683 1234'
    }
  },
  {
    countryNameLocal: 'New Zealand',
    countrySynonymsLocal: '',
    countryCode: 'NZ',
    currencyCode: 'NZD',
    officialLanguageCode: 'mi',
    phoneCode: '+64',
    flag: '🇳🇿',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '21 123 4567',
      example: '+64 21 123 4567'
    }
  },
  {
    countryNameLocal: 'سلطنة عُمان',
    countrySynonymsLocal: '',
    countryCode: 'OM',
    currencyCode: 'OMR',
    officialLanguageCode: 'ar',
    phoneCode: '+968',
    flag: '🇴🇲',
    postalCode: { mask: '999', placeholder: '123', regex: /^\d{3}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9212 3456',
      example: '+968 9212 3456'
    }
  },
  {
    countryNameLocal: 'Panama',
    countrySynonymsLocal: '',
    countryCode: 'PA',
    currencyCode: 'PAB',
    officialLanguageCode: 'es',
    phoneCode: '+507',
    flag: '🇵🇦',
    phoneFormat: {
      mask: '9999-9999',
      placeholder: '6123-4567',
      example: '+507 6123-4567'
    }
  },
  {
    countryNameLocal: 'Perú',
    countrySynonymsLocal: '',
    countryCode: 'PE',
    currencyCode: 'PEN',
    officialLanguageCode: 'es',
    phoneCode: '+51',
    flag: '🇵🇪',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '912 345 678',
      example: '+51 912 345 678'
    }
  },
  {
    countryNameLocal: 'Polynésie française',
    countrySynonymsLocal: '',
    countryCode: 'PF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr',
    phoneCode: '+689',
    flag: '🇵🇫',
    postalCode: { mask: '99999', placeholder: '98713', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '87 12 34 56',
      example: '+689 87 12 34 56'
    }
  },
  {
    countryNameLocal: 'Papua New Guinea',
    countrySynonymsLocal: '',
    countryCode: 'PG',
    currencyCode: 'PGK',
    officialLanguageCode: 'en',
    phoneCode: '+675',
    flag: '🇵🇬',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '712 3456',
      example: '+675 712 3456'
    }
  },
  {
    countryNameLocal: 'پاکستان',
    countrySynonymsLocal: '',
    countryCode: 'PK',
    currencyCode: 'PKR',
    officialLanguageCode: 'en',
    phoneCode: '+92',
    flag: '🇵🇰',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '300 1234567',
      example: '+92 300 1234567'
    }
  },
  {
    countryNameLocal: 'Polska',
    countrySynonymsLocal: '',
    countryCode: 'PL',
    currencyCode: 'PLN',
    officialLanguageCode: 'pl',
    countryName: 'Polen',
    phoneCode: '+48',
    flag: '🇵🇱',
    postalCode: {
      mask: '99-999',
      placeholder: '00-950',
      regex: /^\d{2}-\d{3}$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '501 123 456',
      example: '+48 501 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'PL1234567890',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Saint-Pierre-et-Miquelon',
    countrySynonymsLocal: '',
    countryCode: 'PM',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+508',
    flag: '🇵🇲',
    postalCode: { mask: '99999', placeholder: '97500', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 99 99',
      placeholder: '55 12 34',
      example: '+508 55 12 34'
    }
  },
  {
    countryNameLocal: 'Pitcairn',
    countrySynonymsLocal: '',
    countryCode: 'PN',
    currencyCode: 'NZD',
    officialLanguageCode: 'en',
    phoneCode: '+64',
    flag: '🇵🇳',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '123 456 7890',
      example: '+64 123 456 7890'
    }
  },
  {
    countryNameLocal: 'Puerto Rico',
    countrySynonymsLocal: '',
    countryCode: 'PR',
    currencyCode: 'USD',
    officialLanguageCode: 'es',
    phoneCode: '+1',
    flag: '🇵🇷',
    postalCode: { mask: '99999', placeholder: '00901', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(787) 123-4567',
      example: '+1 (787) 123-4567'
    }
  },
  {
    countryNameLocal: 'Palestinian Territory',
    countrySynonymsLocal: '',
    countryCode: 'PS',
    currencyCode: '',
    officialLanguageCode: 'ar',
    phoneCode: '+970',
    flag: '🇵🇸',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '599 123 456',
      example: '+970 599 123 456'
    }
  },
  {
    countryNameLocal: 'Portugal',
    countrySynonymsLocal: '',
    countryCode: 'PT',
    currencyCode: 'EUR',
    officialLanguageCode: 'pt',
    phoneCode: '+351',
    flag: '🇵🇹',
    postalCode: {
      mask: '9999-999',
      placeholder: '1000-001',
      regex: /^\d{4}-\d{3}$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '912 345 678',
      example: '+351 912 345 678'
    }
  },
  {
    countryNameLocal: 'Palau',
    countrySynonymsLocal: '',
    countryCode: 'PW',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+680',
    flag: '🇵🇼',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '488 1234',
      example: '+680 488 1234'
    }
  },
  {
    countryNameLocal: 'Paraguay',
    countrySynonymsLocal: '',
    countryCode: 'PY',
    currencyCode: 'PYG',
    officialLanguageCode: 'es',
    phoneCode: '+595',
    flag: '🇵🇾',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999999',
      placeholder: '981 123456',
      example: '+595 981 123456'
    }
  },
  {
    countryNameLocal: 'قطر',
    countrySynonymsLocal: '',
    countryCode: 'QA',
    currencyCode: 'QAR',
    officialLanguageCode: 'ar',
    phoneCode: '+974',
    flag: '🇶🇦',
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '3312 3456',
      example: '+974 3312 3456'
    }
  },
  {
    countryNameLocal: 'La Réunion',
    countrySynonymsLocal: '',
    countryCode: 'RE',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+262',
    flag: '🇷🇪',
    postalCode: { mask: '99999', placeholder: '97400', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '692 12 34 56',
      example: '+262 692 12 34 56'
    }
  },
  {
    countryNameLocal: 'România',
    countrySynonymsLocal: '',
    countryCode: 'RO',
    currencyCode: 'RON',
    officialLanguageCode: 'ro',
    countryName: 'Rumänien',
    phoneCode: '+40',
    flag: '🇷🇴',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^(\d{6})$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '721 123 456',
      example: '+40 721 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'RO1234567890',
      regex: /^\d{2,10}$/
    }
  },
  {
    countryNameLocal: 'Србија',
    countrySynonymsLocal: '',
    countryCode: 'RS',
    currencyCode: 'RSD',
    officialLanguageCode: 'sr',
    phoneCode: '+381',
    flag: '🇷🇸',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '60 123 4567',
      example: '+381 60 123 4567'
    }
  },
  {
    countryNameLocal: 'Россия',
    countrySynonymsLocal: '',
    countryCode: 'RU',
    currencyCode: 'RUB',
    officialLanguageCode: 'ru',
    phoneCode: '+7',
    flag: '🇷🇺',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 999 99 99',
      placeholder: '912 345 67 89',
      example: '+7 912 345 67 89'
    }
  },
  {
    countryNameLocal: 'Rwanda',
    countrySynonymsLocal: '',
    countryCode: 'RW',
    currencyCode: 'RWF',
    officialLanguageCode: 'rw',
    phoneCode: '+250',
    flag: '🇷🇼',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '788 123 456',
      example: '+250 788 123 456'
    }
  },
  {
    countryNameLocal: 'السعودية',
    countrySynonymsLocal: '',
    countryCode: 'SA',
    currencyCode: 'SAR',
    officialLanguageCode: 'ar',
    phoneCode: '+966',
    flag: '🇸🇦',
    postalCode: {
      mask: '99999-9999',
      placeholder: '12345-6789',
      regex: /^\d{5}-\d{4}$/
    },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '501 234 567',
      example: '+966 501 234 567'
    }
  },
  {
    countryNameLocal: 'Solomon Islands',
    countrySynonymsLocal: '',
    countryCode: 'SB',
    currencyCode: 'SBD',
    officialLanguageCode: 'en',
    phoneCode: '+677',
    flag: '🇸🇧',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+677 12345'
    }
  },
  {
    countryNameLocal: 'Seychelles',
    countrySynonymsLocal: '',
    countryCode: 'SC',
    currencyCode: 'SCR',
    officialLanguageCode: 'fr',
    phoneCode: '+248',
    flag: '🇸🇨',
    phoneFormat: {
      mask: '9 999 999',
      placeholder: '2 123 456',
      example: '+248 2 123 456'
    }
  },
  {
    countryNameLocal: 'Sverige',
    countrySynonymsLocal: '',
    countryCode: 'SE',
    currencyCode: 'SEK',
    officialLanguageCode: 'sv',
    countryName: 'Schweden',
    phoneCode: '+46',
    flag: '🇸🇪',
    postalCode: {
      mask: '999 99',
      placeholder: '702 36',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '70 123 45 67',
      example: '+46 70 123 45 67'
    },
    vatFormat: {
      mask: '999999999999',
      placeholder: '123456789012',
      example: 'SE123456789012',
      regex: /^\d{12}$/
    }
  },
  {
    countryNameLocal: 'Singapore',
    countrySynonymsLocal: '',
    countryCode: 'SG',
    currencyCode: 'SGD',
    officialLanguageCode: 'zh-hans',
    phoneCode: '+65',
    flag: '🇸🇬',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9123 4567',
      example: '+65 9123 4567'
    }
  },
  {
    countryNameLocal: 'Saint Helena',
    countrySynonymsLocal: '',
    countryCode: 'SH',
    currencyCode: 'SHP',
    officialLanguageCode: 'en',
    phoneCode: '+290',
    flag: '🇸🇭',
    phoneFormat: {
      mask: '9999',
      placeholder: '1234',
      example: '+290 1234'
    }
  },
  {
    countryNameLocal: 'Slovenija',
    countrySynonymsLocal: '',
    countryCode: 'SI',
    currencyCode: 'EUR',
    officialLanguageCode: 'sl',
    countryName: 'Slowenien',
    phoneCode: '+386',
    flag: '🇸🇮',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^(\d{4})$/ },
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '31 123 456',
      example: '+386 31 123 456'
    },
    vatFormat: {
      mask: '99999999',
      placeholder: '12345678',
      example: 'SI12345678',
      regex: /^\d{8}$/
    }
  },
  {
    countryNameLocal: 'Svalbard and Jan Mayen',
    countrySynonymsLocal: '',
    countryCode: 'SJ',
    currencyCode: 'NOK',
    officialLanguageCode: 'no',
    phoneCode: '+47',
    flag: '🇸🇯',
    postalCode: { mask: '9999', placeholder: '9170', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 99 999',
      placeholder: '412 34 567',
      example: '+47 412 34 567'
    }
  },
  {
    countryNameLocal: 'Slovensko',
    countrySynonymsLocal: '',
    countryCode: 'SK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sk',
    countryName: 'Slowakei',
    phoneCode: '+421',
    flag: '🇸🇰',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '901 123 456',
      example: '+421 901 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '1234567890',
      example: 'SK1234567890',
      regex: /^\d{10}$/
    }
  },
  {
    countryNameLocal: 'Sierra Leone',
    countrySynonymsLocal: '',
    countryCode: 'SL',
    currencyCode: 'SLL',
    officialLanguageCode: 'en',
    phoneCode: '+232',
    flag: '🇸🇱',
    phoneFormat: {
      mask: '99 999999',
      placeholder: '76 123456',
      example: '+232 76 123456'
    }
  },
  {
    countryNameLocal: 'Repubblica di San Marino',
    countrySynonymsLocal: '',
    countryCode: 'SM',
    currencyCode: 'EUR',
    officialLanguageCode: 'it',
    phoneCode: '+378',
    flag: '🇸🇲',
    postalCode: { mask: '99999', placeholder: '47890', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '6123 456789',
      example: '+378 6123 456789'
    }
  },
  {
    countryNameLocal: 'Sénégal',
    countrySynonymsLocal: '',
    countryCode: 'SN',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+221',
    flag: '🇸🇳',
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '77 123 45 67',
      example: '+221 77 123 45 67'
    }
  },
  {
    countryNameLocal: 'Somalia, الصومال',
    countrySynonymsLocal: '',
    countryCode: 'SO',
    currencyCode: 'SOS',
    officialLanguageCode: 'so',
    countryName: 'Somalia',
    phoneCode: '+252',
    flag: '🇸🇴',
    postalCode: {
      mask: 'aa 99999',
      placeholder: 'AB 12345',
      regex: /^[A-Z]{2} \d{5}$/
    },
    phoneFormat: {
      mask: '99 9999999',
      placeholder: '61 1234567',
      example: '+252 61 1234567'
    },
    vatFormat: {
      mask: '999999999',
      placeholder: '123456789',
      example: 'SO123456789',
      regex: /^\d{9}$/
    }
  },
  {
    countryNameLocal: 'Suriname',
    countrySynonymsLocal: '',
    countryCode: 'SR',
    currencyCode: 'SRD',
    officialLanguageCode: 'nl',
    phoneCode: '+597',
    flag: '🇸🇷',
    phoneFormat: {
      mask: '999-9999',
      placeholder: '712-3456',
      example: '+597 712-3456'
    }
  },
  {
    countryNameLocal: 'South Sudan',
    countrySynonymsLocal: '',
    countryCode: 'SS',
    currencyCode: 'SSP',
    officialLanguageCode: 'en',
    phoneCode: '+211',
    flag: '🇸🇸',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '912 345 678',
      example: '+211 912 345 678'
    }
  },
  {
    countryNameLocal: 'São Tomé e Príncipe',
    countrySynonymsLocal: '',
    countryCode: 'ST',
    currencyCode: 'STN',
    officialLanguageCode: 'pt',
    phoneCode: '+239',
    flag: '🇸🇹',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '990 1234',
      example: '+239 990 1234'
    }
  },
  {
    countryNameLocal: 'El Salvador',
    countrySynonymsLocal: '',
    countryCode: 'SV',
    currencyCode: 'SVC',
    officialLanguageCode: 'es',
    phoneCode: '+503',
    flag: '🇸🇻',
    phoneFormat: {
      mask: '9999-9999',
      placeholder: '7123-4567',
      example: '+503 7123-4567'
    }
  },
  {
    countryNameLocal: 'Sint Maarten',
    countrySynonymsLocal: '',
    countryCode: 'SX',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl',
    phoneCode: '+1',
    flag: '🇸🇽',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(721) 123-4567',
      example: '+1 (721) 123-4567'
    }
  },
  {
    countryNameLocal: 'سوريا, Sūriyya',
    countrySynonymsLocal: '',
    countryCode: 'SY',
    currencyCode: 'SYP',
    officialLanguageCode: 'ar',
    phoneCode: '+963',
    flag: '🇸🇾',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '912 345 678',
      example: '+963 912 345 678'
    }
  },
  {
    countryNameLocal: 'Tchad, تشاد',
    countrySynonymsLocal: '',
    countryCode: 'TD',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr',
    phoneCode: '+235',
    flag: '🇹🇩',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '66 12 34 56',
      example: '+235 66 12 34 56'
    }
  },
  {
    countryNameLocal: 'Togo',
    countrySynonymsLocal: '',
    countryCode: 'TG',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+228',
    flag: '🇹🇬',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '90 12 34 56',
      example: '+228 90 12 34 56'
    }
  },
  {
    countryNameLocal: 'ประเทศไทย',
    countrySynonymsLocal: '',
    countryCode: 'TH',
    currencyCode: 'THB',
    officialLanguageCode: 'th',
    phoneCode: '+66',
    flag: '🇹🇭',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '812 345 678',
      example: '+66 812 345 678'
    }
  },
  {
    countryNameLocal: ',',
    countrySynonymsLocal: '',
    countryCode: 'TJ',
    currencyCode: 'TJS',
    officialLanguageCode: 'tg',
    phoneCode: '+992',
    flag: '🇹🇯',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '999 99 9999',
      placeholder: '917 12 3456',
      example: '+992 917 12 3456'
    }
  },
  {
    countryNameLocal: 'Tokelau',
    countrySynonymsLocal: '',
    countryCode: 'TK',
    currencyCode: 'NZD',
    officialLanguageCode: 'tkl',
    phoneCode: '+690',
    flag: '🇹🇰',
    phoneFormat: {
      mask: '9999',
      placeholder: '1234',
      example: '+690 1234'
    }
  },
  {
    countryNameLocal: "Timor-Leste, Timor Lorosa'e",
    countrySynonymsLocal: '',
    countryCode: 'TL',
    currencyCode: 'USD',
    officialLanguageCode: 'pt',
    phoneCode: '+670',
    flag: '🇹🇱',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '772 1234',
      example: '+670 772 1234'
    }
  },
  {
    countryNameLocal: 'Türkmenistan',
    countrySynonymsLocal: '',
    countryCode: 'TM',
    currencyCode: 'TMT',
    officialLanguageCode: 'tk',
    phoneCode: '+993',
    flag: '🇹🇲',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '99 99-99-99',
      placeholder: '61 23-45-67',
      example: '+993 61 23-45-67'
    }
  },
  {
    countryNameLocal: 'تونس, Tunisie',
    countrySynonymsLocal: '',
    countryCode: 'TN',
    currencyCode: 'TND',
    officialLanguageCode: 'ar',
    phoneCode: '+216',
    flag: '🇹🇳',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '92 123 456',
      example: '+216 92 123 456'
    }
  },
  {
    countryNameLocal: 'Tonga',
    countrySynonymsLocal: '',
    countryCode: 'TO',
    currencyCode: 'TOP',
    officialLanguageCode: 'en',
    phoneCode: '+676',
    flag: '🇹🇴',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+676 12345'
    }
  },
  {
    countryNameLocal: 'Türkiye',
    countrySynonymsLocal: '',
    countryCode: 'TR',
    currencyCode: 'TRY',
    officialLanguageCode: 'tr',
    phoneCode: '+90',
    flag: '🇹🇷',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 999 99 99',
      placeholder: '532 123 45 67',
      example: '+90 532 123 45 67'
    }
  },
  {
    countryNameLocal: 'Trinidad and Tobago',
    countrySynonymsLocal: '',
    countryCode: 'TT',
    currencyCode: 'TTD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇹🇹',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(868) 123-4567',
      example: '+1 (868) 123-4567'
    }
  },
  {
    countryNameLocal: 'Tuvalu',
    countrySynonymsLocal: '',
    countryCode: 'TV',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+688',
    flag: '🇹🇻',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+688 12345'
    }
  },
  {
    countryNameLocal: 'Tanzania',
    countrySynonymsLocal: '',
    countryCode: 'TZ',
    currencyCode: 'TZS',
    officialLanguageCode: 'sw',
    phoneCode: '+255',
    flag: '🇹🇿',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{4,5}$/ },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '712 123 456',
      example: '+255 712 123 456'
    }
  },
  {
    countryNameLocal: 'Україна',
    countrySynonymsLocal: '',
    countryCode: 'UA',
    currencyCode: 'UAH',
    officialLanguageCode: 'uk',
    phoneCode: '+380',
    flag: '🇺🇦',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '50 123 4567',
      example: '+380 50 123 4567'
    }
  },
  {
    countryNameLocal: 'Uganda',
    countrySynonymsLocal: '',
    countryCode: 'UG',
    currencyCode: 'UGX',
    officialLanguageCode: 'en',
    phoneCode: '+256',
    flag: '🇺🇬',
    phoneFormat: {
      mask: '999 999999',
      placeholder: '712 345678',
      example: '+256 712 345678'
    }
  },
  {
    countryNameLocal: 'United States of America',
    countrySynonymsLocal: 'USA Amerika America',
    countryCode: 'US',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    countryName: 'USA',
    phoneCode: '+1',
    flag: '🇺🇸',
    postalCode: {
      mask: '99999-9999',
      placeholder: '12345',
      regex: /^\d{5}(-\d{4})?$/
    },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(555) 123-4567',
      example: '+1 (555) 123-4567'
    },
    vatFormat: {
      mask: '99-9999999',
      placeholder: '12-3456789',
      example: 'US12-3456789',
      regex: /^\d{2}-\d{7}$/
    }
  },
  {
    countryNameLocal: 'Uruguay',
    countrySynonymsLocal: '',
    countryCode: 'UY',
    currencyCode: 'UYU',
    officialLanguageCode: 'es',
    phoneCode: '+598',
    flag: '🇺🇾',
    postalCode: { mask: '99999', placeholder: '12345', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '9912 3456',
      example: '+598 9912 3456'
    }
  },
  {
    countryNameLocal: '',
    countrySynonymsLocal: '',
    countryCode: 'UZ',
    currencyCode: 'UZS',
    officialLanguageCode: 'uz',
    phoneCode: '+998',
    flag: '🇺🇿',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{6}$/ },
    phoneFormat: {
      mask: '99 999 99 99',
      placeholder: '90 123 45 67',
      example: '+998 90 123 45 67'
    }
  },
  {
    countryNameLocal: 'Saint Vincent and the Grenadines',
    countrySynonymsLocal: '',
    countryCode: 'VC',
    currencyCode: 'XCD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇻🇨',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(784) 123-4567',
      example: '+1 (784) 123-4567'
    }
  },
  {
    countryNameLocal: 'Venezuela',
    countrySynonymsLocal: '',
    countryCode: 'VE',
    currencyCode: 'VES',
    officialLanguageCode: 'es',
    phoneCode: '+58',
    flag: '🇻🇪',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999-999.9999',
      placeholder: '412-123.4567',
      example: '+58 412-123.4567'
    }
  },
  {
    countryNameLocal: 'British Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VG',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇻🇬',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(284) 123-4567',
      example: '+1 (284) 123-4567'
    }
  },
  {
    countryNameLocal: 'United States Virgin Islands',
    countrySynonymsLocal: '',
    countryCode: 'VI',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇻🇮',
    postalCode: { mask: '99999', placeholder: '00801', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(340) 123-4567',
      example: '+1 (340) 123-4567'
    }
  },
  {
    countryNameLocal: 'Việt Nam',
    countrySynonymsLocal: '',
    countryCode: 'VN',
    currencyCode: 'VND',
    officialLanguageCode: 'vi',
    phoneCode: '+84',
    flag: '🇻🇳',
    postalCode: { mask: '999999', placeholder: '123456', regex: /^\d{5,6}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '912 345 678',
      example: '+84 912 345 678'
    }
  },
  {
    countryNameLocal: 'Vanuatu',
    countrySynonymsLocal: '',
    countryCode: 'VU',
    currencyCode: 'VUV',
    officialLanguageCode: 'bi',
    phoneCode: '+678',
    flag: '🇻🇺',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '555 1234',
      example: '+678 555 1234'
    }
  },
  {
    countryNameLocal: 'Wallis-et-Futuna',
    countrySynonymsLocal: '',
    countryCode: 'WF',
    currencyCode: 'XPF',
    officialLanguageCode: 'fr',
    phoneCode: '+681',
    flag: '🇼🇫',
    postalCode: { mask: '99999', placeholder: '98600', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '99 99 99',
      placeholder: '72 12 34',
      example: '+681 72 12 34'
    }
  },
  {
    countryNameLocal: 'Samoa',
    countrySynonymsLocal: '',
    countryCode: 'WS',
    currencyCode: 'WST',
    officialLanguageCode: 'sm',
    phoneCode: '+685',
    flag: '🇼🇸',
    phoneFormat: {
      mask: '99999',
      placeholder: '12345',
      example: '+685 12345'
    }
  },
  {
    countryNameLocal: 'اليَمَن',
    countrySynonymsLocal: '',
    countryCode: 'YE',
    currencyCode: 'YER',
    officialLanguageCode: 'ar',
    phoneCode: '+967',
    flag: '🇾🇪',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '712 345 678',
      example: '+967 712 345 678'
    }
  },
  {
    countryNameLocal: 'Mayotte',
    countrySynonymsLocal: '',
    countryCode: 'YT',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+262',
    flag: '🇾🇹',
    postalCode: { mask: '99999', placeholder: '97600', regex: /^\d{5}$/ },
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '639 12 34 56',
      example: '+262 639 12 34 56'
    }
  },
  {
    countryNameLocal: 'South Africa',
    countrySynonymsLocal: '',
    countryCode: 'ZA',
    currencyCode: 'ZAR',
    officialLanguageCode: 'en',
    phoneCode: '+27',
    flag: '🇿🇦',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '82 123 4567',
      example: '+27 82 123 4567'
    }
  },
  {
    countryNameLocal: 'Zambia',
    countrySynonymsLocal: '',
    countryCode: 'ZM',
    currencyCode: 'ZMW',
    officialLanguageCode: 'en',
    phoneCode: '+260',
    flag: '🇿🇲',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '955 123 456',
      example: '+260 955 123 456'
    }
  },
  {
    countryNameLocal: 'Zimbabwe',
    countrySynonymsLocal: '',
    countryCode: 'ZW',
    currencyCode: 'ZWL',
    officialLanguageCode: 'en',
    phoneCode: '+263',
    flag: '🇿🇼',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '712 123 456',
      example: '+263 712 123 456'
    }
  },
  {
    countryNameLocal: 'Swaziland',
    countrySynonymsLocal: '',
    countryCode: 'SZ',
    currencyCode: 'SZL',
    officialLanguageCode: 'en',
    phoneCode: '+268',
    flag: '🇸🇿',
    phoneFormat: {
      mask: '9999 9999',
      placeholder: '7612 3456',
      example: '+268 7612 3456'
    }
  },
  {
    countryNameLocal: 'Македонија',
    countrySynonymsLocal: '',
    countryCode: 'MK',
    currencyCode: 'MKD',
    officialLanguageCode: 'mk',
    phoneCode: '+389',
    flag: '🇲🇰',
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '70 123 456',
      example: '+389 70 123 456'
    }
  },
  {
    countryNameLocal: 'Philippines',
    countrySynonymsLocal: '',
    countryCode: 'PH',
    currencyCode: 'PHP',
    officialLanguageCode: 'en',
    countryName: 'Philippinen',
    phoneCode: '+63',
    flag: '🇵🇭',
    postalCode: { mask: '9999', placeholder: '1234', regex: /^\d{4}$/ },
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '917 123 4567',
      example: '+63 917 123 4567'
    },
    vatFormat: {
      mask: '999-999-999-99999',
      placeholder: '123-456-789-01234',
      example: 'PH123-456-789-01234',
      regex: /^\d{3}-\d{3}-\d{3}-\d{5}$/
    }
  },
  {
    countryNameLocal: 'Nederland',
    countrySynonymsLocal: '',
    countryCode: 'NL',
    currencyCode: 'EUR',
    officialLanguageCode: 'nl',
    countryName: 'Niederlande',
    phoneCode: '+31',
    flag: '🇳🇱',
    postalCode: {
      mask: '9999 aa',
      placeholder: '1234 AB',
      regex: /^[0-9]{4} [A-Z]{2}$/
    },
    phoneFormat: {
      mask: '9 99999999',
      placeholder: '6 12345678',
      example: '+31 6 12345678'
    },
    vatFormat: {
      mask: 'aa999999999*99',
      placeholder: 'NL123456789B01',
      example: 'NL123456789B01',
      regex: /^NL\d{9}[A-Z]\d{2}$/
    }
  },
  {
    countryNameLocal: 'دولة الإمارات العربيّة المتّحدة',
    countrySynonymsLocal: '',
    countryCode: 'AE',
    currencyCode: 'AED',
    officialLanguageCode: 'ar',
    phoneCode: '+971',
    flag: '🇦🇪',
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '50 123 4567',
      example: '+971 50 123 4567'
    }
  },
  {
    countryNameLocal: 'Moldova, Молдавия',
    countrySynonymsLocal: '',
    countryCode: 'MD',
    currencyCode: 'MDL',
    officialLanguageCode: 'ro',
    phoneCode: '+373',
    flag: '🇲🇩',
    phoneFormat: {
      mask: '999 99999',
      placeholder: '691 23456',
      example: '+373 691 23456'
    }
  },
  {
    countryNameLocal: 'The Gambia',
    countrySynonymsLocal: '',
    countryCode: 'GM',
    currencyCode: 'GMD',
    officialLanguageCode: 'en',
    phoneCode: '+220',
    flag: '🇬🇲',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '700 1234',
      example: '+220 700 1234'
    }
  },
  {
    countryNameLocal: 'República Dominicana',
    countrySynonymsLocal: '',
    countryCode: 'DO',
    currencyCode: 'DOP',
    officialLanguageCode: 'es',
    phoneCode: '+1',
    flag: '🇩🇴',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(809) 123-4567',
      example: '+1 (809) 123-4567'
    }
  },
  {
    countryNameLocal: 'السودان',
    countrySynonymsLocal: '',
    countryCode: 'SD',
    currencyCode: 'SDG',
    officialLanguageCode: 'ar',
    phoneCode: '+249',
    flag: '🇸🇩',
    phoneFormat: {
      mask: '999 999 9999',
      placeholder: '91 123 4567',
      example: '+249 91 123 4567'
    }
  },
  {
    countryNameLocal: 'ປະຊາຊົນລາວ',
    countrySynonymsLocal: '',
    countryCode: 'LA',
    currencyCode: 'LAK',
    officialLanguageCode: 'lo',
    phoneCode: '+856',
    flag: '🇱🇦',
    phoneFormat: {
      mask: '99 20 123 456',
      placeholder: '20 123 456',
      example: '+856 20 123 456'
    }
  },
  {
    countryNameLocal: 'Taiwan',
    countrySynonymsLocal: '',
    countryCode: 'TW',
    currencyCode: 'TWD',
    officialLanguageCode: 'zh-hant',
    phoneCode: '+886',
    flag: '🇹🇼',
    postalCode: { mask: '99999', placeholder: '10001', regex: /^\d{3,5}$/ },
    phoneFormat: {
      mask: '999-999-999',
      placeholder: '912-345-678',
      example: '+886-912-345-678'
    }
  },
  {
    countryNameLocal: 'République du Congo',
    countrySynonymsLocal: '',
    countryCode: 'CG',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr',
    phoneCode: '+242',
    flag: '🇨🇬',
    phoneFormat: {
      mask: '99 999 9999',
      placeholder: '06 123 4567',
      example: '+242 06 123 4567'
    }
  },
  {
    countryNameLocal: 'Česká republika',
    countrySynonymsLocal: '',
    countryCode: 'CZ',
    currencyCode: 'CZK',
    officialLanguageCode: 'cs',
    countryName: 'Tschechien',
    phoneCode: '+420',
    flag: '🇨🇿',
    postalCode: {
      mask: '999 99',
      placeholder: '123 45',
      regex: /^(\d{3} \d{2})$/
    },
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '601 123 456',
      example: '+420 601 123 456'
    },
    vatFormat: {
      mask: '9999999999',
      placeholder: '12345678',
      example: 'CZ12345678',
      regex: /^\d{8,10}$/
    }
  },
  {
    countryNameLocal: 'Great Britain',
    countrySynonymsLocal: 'UK England GB',
    countryCode: 'GB',
    currencyCode: 'GBP',
    officialLanguageCode: 'en',
    countryName: 'Vereinigtes Königreich',
    phoneCode: '+44',
    flag: '🇬🇧',
    postalCode: {
      mask: 'a*9 9**',
      placeholder: 'SW1A 1AA',
      regex:
        /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/
    },
    phoneFormat: {
      mask: '9999 999999',
      placeholder: '7123 456789',
      example: '+44 7123 456789'
    },
    vatFormat: {
      mask: 'aa999999999',
      placeholder: 'GB123456789',
      example: 'GB123456789',
      regex: /^GB\d{9}$/
    }
  },
  {
    countryNameLocal: 'Niger',
    countrySynonymsLocal: '',
    countryCode: 'NE',
    currencyCode: 'XOF',
    officialLanguageCode: 'fr',
    phoneCode: '+227',
    flag: '🇳🇪',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '90 12 34 56',
      example: '+227 90 12 34 56'
    }
  },
  {
    countryNameLocal: 'Democratic Republic of the Congo',
    countrySynonymsLocal: '',
    countryCode: 'CD',
    currencyCode: 'CDF',
    officialLanguageCode: 'fr',
    phoneCode: '+243',
    flag: '🇨🇩',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '999 123 456',
      example: '+243 999 123 456'
    }
  },
  {
    countryNameLocal: 'Commonwealth of The Bahamas',
    countrySynonymsLocal: '',
    countryCode: 'BS',
    currencyCode: 'BSD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇧🇸',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(242) 359-1234',
      example: '+1 (242) 359-1234'
    }
  },
  {
    countryNameLocal: 'Pulu Kokos (Keeling)',
    countrySynonymsLocal: '',
    countryCode: 'CC',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+61',
    flag: '🇨🇨',
    phoneFormat: {
      mask: '999 999 999',
      placeholder: '916 123 456',
      example: '+61 916 123 456'
    }
  },
  {
    countryNameLocal: 'République centrafricaine',
    countrySynonymsLocal: '',
    countryCode: 'CF',
    currencyCode: 'XAF',
    officialLanguageCode: 'fr',
    phoneCode: '+236',
    flag: '🇨🇫',
    phoneFormat: {
      mask: '99 99 99 99',
      placeholder: '70 12 34 56',
      example: '+236 70 12 34 56'
    }
  },
  {
    countryNameLocal: "Kūki 'Āirani",
    countrySynonymsLocal: '',
    countryCode: 'CK',
    currencyCode: 'NZD',
    officialLanguageCode: 'en',
    phoneCode: '+682',
    flag: '🇨🇰',
    phoneFormat: {
      mask: '99 999',
      placeholder: '55 123',
      example: '+682 55 123'
    }
  },
  {
    countryNameLocal: 'Falkland Islands',
    countrySynonymsLocal: '',
    countryCode: 'FK',
    currencyCode: 'FKP',
    officialLanguageCode: 'en',
    phoneCode: '+500',
    flag: '🇫🇰',
    phoneFormat: {
      mask: '99999',
      placeholder: '27123',
      example: '+500 27123'
    }
  },
  {
    countryNameLocal: 'Færøerne',
    countrySynonymsLocal: '',
    countryCode: 'FO',
    currencyCode: 'DKK',
    officialLanguageCode: 'da',
    phoneCode: '+298',
    flag: '🇫🇴',
    phoneFormat: {
      mask: '999999',
      placeholder: '211234',
      example: '+298 211234'
    }
  },
  {
    countryNameLocal: 'Territory of Heard Island and McDonald Islands',
    countrySynonymsLocal: '',
    countryCode: 'HM',
    currencyCode: 'AUD',
    officialLanguageCode: 'en',
    phoneCode: '+672',
    flag: '🇭🇲',
    phoneFormat: {
      mask: '999 999',
      placeholder: '123 456',
      example: '+672 123 456'
    }
  },
  {
    countryNameLocal: 'British Indian Ocean Territory',
    countrySynonymsLocal: '',
    countryCode: 'IO',
    currencyCode: 'USD',
    officialLanguageCode: 'en'
  },
  {
    countryNameLocal: 'Umoja wa Komori',
    countrySynonymsLocal: '',
    countryCode: 'KM',
    currencyCode: 'KMF',
    officialLanguageCode: 'fr',
    phoneCode: '+269',
    flag: '🇰🇲',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '321 2345',
      example: '+269 321 2345'
    }
  },
  {
    countryNameLocal: 'Cayman Islands',
    countrySynonymsLocal: '',
    countryCode: 'KY',
    currencyCode: 'KYD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇰🇾',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(345) 323-1234',
      example: '+1 (345) 323-1234'
    }
  },
  {
    countryNameLocal: 'Aolepān Aorōkin Ṃajeḷ',
    countrySynonymsLocal: '',
    countryCode: 'MH',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+692',
    flag: '🇲🇭',
    phoneFormat: {
      mask: '999 9999',
      placeholder: '555 1234',
      example: '+692 555 1234'
    }
  },
  {
    countryNameLocal: 'Sankattan Siha Na Islas Mariånas',
    countrySynonymsLocal: '',
    countryCode: 'MP',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇲🇵',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(670) 234-5678',
      example: '+1 (670) 234-5678'
    }
  },
  {
    countryNameLocal: 'Turks and Caicos Islands',
    countrySynonymsLocal: '',
    countryCode: 'TC',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇹🇨',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(649) 231-1234',
      example: '+1 (649) 231-1234'
    }
  },
  {
    countryNameLocal: 'Terres australes et antarctiques françaises',
    countrySynonymsLocal: '',
    countryCode: 'TF',
    currencyCode: 'EUR',
    officialLanguageCode: 'fr',
    phoneCode: '+262',
    flag: '🇹🇫',
    phoneFormat: {
      mask: '999 99 99 99',
      placeholder: '692 12 34 56',
      example: '+262 692 12 34 56'
    }
  },
  {
    countryNameLocal: 'United States Minor Outlying Islands',
    countrySynonymsLocal: '',
    countryCode: 'UM',
    currencyCode: 'USD',
    officialLanguageCode: 'en',
    phoneCode: '+1',
    flag: '🇺🇲',
    phoneFormat: {
      mask: '(999) 999-9999',
      placeholder: '(808) 123-4567',
      example: '+1 (808) 123-4567'
    }
  },
  {
    countryNameLocal: 'Sancta Sedes',
    countrySynonymsLocal: '',
    countryCode: 'VA',
    currencyCode: 'EUR',
    officialLanguageCode: 'la',
    phoneCode: '+39',
    flag: '🇻🇦',
    phoneFormat: {
      mask: '999 9999999',
      placeholder: '06 69812345',
      example: '+39 06 69812345'
    }
  },
  {
    countryNameLocal: 'Republika e Kosovës',
    countrySynonymsLocal: '',
    countryCode: 'XK',
    currencyCode: 'EUR',
    officialLanguageCode: 'sq',
    phoneCode: '+383',
    flag: '🇽🇰',
    phoneFormat: {
      mask: '99 999 999',
      placeholder: '44 123 456',
      example: '+383 44 123 456'
    }
  },
  {
    countryNameLocal: 'Nederlandse Antillen',
    countrySynonymsLocal: '',
    countryCode: 'AN',
    currencyCode: 'ANG',
    officialLanguageCode: 'nl',
    phoneCode: '+599',
    flag: '🇦🇳',
    phoneFormat: {
      mask: '9 999 9999',
      placeholder: '9 123 4567',
      example: '+599 9 123 4567'
    }
  }
] as const;

export const countries: Country[] = rawCountries.map((country) => ({
  ...country,
  phoneFormat:
    'phoneFormat' in country && country.phoneFormat
      ? {
          mask: country.phoneFormat.mask,
          placeholder: country.phoneFormat.placeholder
        }
      : undefined
}));

const normalizePhonePlaceholder = (
  placeholder: string,
  phoneCode?: string
): string => {
  let normalized = placeholder.trim();

  if (phoneCode) {
    const codeDigits = phoneCode.replace('+', '');
    normalized = normalized.replace(
      new RegExp(`^\\+?${codeDigits}[\\s-]*`),
      ''
    );
  }

  // Remove leading area/country-like prefix in brackets, e.g. "(268) 123-4567" -> "123-4567"
  normalized = normalized.replace(/^\(\d{2,4}\)\s*/, '');

  return normalized.trim();
};

/**
 * Country configuration helper notes
 *
 * The exported `countries` array is normalized from `rawCountries`.
 * For `phoneFormat`, only `mask` and `placeholder` are kept.
 * Any legacy phone examples/regexes in `rawCountries` are intentionally ignored.
 *
 * Sources:
 * - Postal codes: https://bpost.freshdesk.com/support/solutions/articles/4000040467-international-zip-code-masks-for-seamless-shipping-with-bpost
 * - Phone prefixes: https://www.npmjs.com/package/country-codes-list
 * - ITU-T E.164: https://www.itu.int/rec/T-REC-E.164/
 * - VAT formats: https://avalara.com/vatlive/en/eu-vat-rules/eu-vat-number-registration/eu-vat-number-formats.html
 */

/**
 * Hilfsfunktionen für die Länderverarbeitung
 */

// Erstellt eine Map von Ländercode zu PLZ-Pattern
export const getPostalCodePatterns = () => {
  const patterns: Record<
    string,
    { mask: string; placeholder: string; regex: RegExp }
  > = {};
  countries.forEach((country) => {
    if (country.postalCode) {
      patterns[country.countryCode] = country.postalCode;
    }
  });
  return patterns;
};

// Erstellt eine Map von Ländercode zu Phone-Pattern
export const getPhonePatterns = () => {
  const patterns: Record<
    string,
    {
      code: string;
      flag: string;
      format: {
        mask: string;
        placeholder: string;
      };
    }
  > = {};
  countries.forEach((country) => {
    if (country.phoneCode && country.flag && country.phoneFormat) {
      patterns[country.countryCode] = {
        code: country.phoneCode,
        flag: country.flag,
        format: {
          ...country.phoneFormat,
          placeholder: normalizePhonePlaceholder(
            country.phoneFormat.placeholder,
            country.phoneCode
          )
        }
      };
    }
  });
  return patterns;
};

// Erstellt eine Map von Ländercode zu VAT-Pattern
export const getVatPatterns = () => {
  const patterns: Record<string, {}> = {};
  countries.forEach((country) => {
    if (country.vatFormat) {
      patterns[country.countryCode] = country.vatFormat;
    }
  });
  return patterns;
};

// Findet ein Land anhand des Codes
export const getCountryByCode = (code: string) => {
  const country = countries.find((entry) => entry.countryCode === code);
  if (!country?.phoneFormat) {
    return country;
  }

  return {
    ...country,
    phoneFormat: {
      ...country.phoneFormat,
      placeholder: normalizePhonePlaceholder(
        country.phoneFormat.placeholder,
        country.phoneCode
      )
    }
  };
};

// Gibt alle verfügbaren Ländercodes zurück
export const getCountryCodes = () => {
  return countries.map((country) => country.countryCode);
};

// Erstellt eine sortierte Liste nach Namen
export const getCountriesSortedByName = () => {
  return [...countries].sort((a, b) =>
    a.countryNameLocal.localeCompare(b.countryNameLocal, 'de')
  );
};

/**
 * Countries for which the WebApp still performs a postal code format check as a
 * fallback. This only applies when Magento supplies no validation rules for the
 * postcode field. Any country not listed here (notably the US) has no WebApp
 * postal code format validation at all.
 */
export const POSTAL_CODE_VALIDATION_COUNTRIES = new Set<string>([
  'AD',
  'AR',
  'BR',
  'CA',
  'CZ',
  'GR',
  'JP',
  'KR',
  'MT',
  'NL',
  'PL',
  'PT',
  'SE',
  'SK',
  'SO'
]);

// Validiert eine PLZ für ein bestimmtes Land
export const validatePostalCode = (
  postalCode: string,
  countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!postalCode || !countryCode) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.postalCode.required'] ??
        'Postal code and country code are required'
    };
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      isValid: false,
      message: dictionary?.['validation.country.unknown'] ?? 'Unknown country'
    };
  }

  // Only a fixed allow-list of countries is validated in the WebApp; everything
  // else (e.g. US) is treated as valid (no format validation).
  if (!POSTAL_CODE_VALIDATION_COUNTRIES.has(countryCode.toUpperCase())) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.postalCode.noValidation'] ??
        'No validation available'
    };
  }

  const { regex, placeholder } = country.postalCode ?? {};
  if (!regex) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.postalCode.noValidation'] ??
        'No validation available'
    };
  }

  const isValid = regex.test(postalCode);
  return {
    isValid,
    message: isValid
      ? (dictionary?.['validation.postalCode.valid'] ?? 'Postal code is valid')
      : dictionary?.['validation.postalCode.invalidFormat']
        ? dictionary['validation.postalCode.invalidFormat'].replace(
            '{placeholder}',
            placeholder ?? ''
          )
        : `Postal code does not match the expected format: ${placeholder}`
  };
};

// Validiert eine Telefonnummer für ein bestimmtes Land
export const validatePhoneNumber = (
  phoneNumber: string,
  _countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!phoneNumber) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.phoneNumber.required'] ??
        'Phone number is required'
    };
  }

  // Common validation for all countries:
  // - digits and spaces only
  // - 5 to 15 digits (spaces are ignored)
  const hasOnlyDigitsAndSpaces = /^[0-9 ]+$/.test(phoneNumber);
  const digitsOnly = phoneNumber.replace(/\s/g, '');
  const hasValidLength = digitsOnly.length >= 5 && digitsOnly.length <= 15;
  const isValid = hasOnlyDigitsAndSpaces && hasValidLength;

  return {
    isValid,
    message: isValid
      ? (dictionary?.['validation.phoneNumber.valid'] ??
        'Phone number is valid')
      : (dictionary?.['validation.phoneNumber.invalidFormat'] ??
        'Phone number must contain only digits and spaces and be 5 to 15 digits long')
  };
};

// Formatiert eine internationale Telefonnummer
export const formatInternationalPhone = (
  localNumber: string,
  countryCode: string
) => {
  if (!localNumber || !countryCode) {
    return localNumber;
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return localNumber;
  }

  // Entferne alle nicht-numerischen Zeichen außer +
  const cleanNumber = localNumber.replace(/[^\d+]/g, '');

  // Wenn bereits internationale Nummer (beginnt mit +), gib sie zurück
  if (cleanNumber.startsWith('+')) {
    return cleanNumber;
  }

  // Entferne führende 0 falls vorhanden (typisch für nationale Nummern)
  const withoutLeadingZero = cleanNumber.startsWith('0')
    ? cleanNumber.substring(1)
    : cleanNumber;

  return `${country.phoneCode} ${withoutLeadingZero}`;
};

// Validiert eine VAT-Nummer für ein bestimmtes Land
export const validateVatNumber = (
  vatNumber: string,
  countryCode: string,
  dictionary?: Record<string, string>
) => {
  if (!vatNumber || !countryCode) {
    return {
      isValid: false,
      message:
        dictionary?.['validation.vatNumber.required'] ??
        'VAT number and country code are required'
    };
  }

  const country = getCountryByCode(countryCode);
  if (!country) {
    return {
      isValid: false,
      message: dictionary?.['validation.country.unknown'] ?? 'Unknown country'
    };
  }

  if (!country.vatFormat) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.vatNumber.noValidationForCountry'] ??
        'No VAT validation available for this country'
    };
  }

  const { regex, placeholder } = country.vatFormat;
  if (!regex) {
    return {
      isValid: true,
      message:
        dictionary?.['validation.vatNumber.noValidation'] ??
        'No VAT validation available'
    };
  }

  const isValid = regex.test(vatNumber);
  return {
    isValid,
    message: isValid
      ? (dictionary?.['validation.vatNumber.valid'] ?? 'VAT number is valid')
      : dictionary?.['validation.vatNumber.invalidFormat']
        ? dictionary['validation.vatNumber.invalidFormat'].replace(
            '{placeholder}',
            placeholder ?? ''
          )
        : `VAT number does not match the expected format: ${placeholder}`
  };
};

// Formatiert eine VAT-Nummer mit Ländercode
export const formatInternationalVat = (
  localVatNumber: string,
  countryCode: string
) => {
  if (!localVatNumber || !countryCode) {
    return localVatNumber;
  }

  const country = getCountryByCode(countryCode);
  if (!country || !country.vatFormat) {
    return localVatNumber;
  }

  // Entferne Ländercode falls bereits vorhanden
  const cleanVat = localVatNumber
    .replace(new RegExp(`^${countryCode}`, 'i'), '')
    .trim();

  // Wenn bereits vollständige VAT-Nummer (beginnt mit Ländercode), gib sie zurück
  if (localVatNumber.toUpperCase().startsWith(countryCode)) {
    return localVatNumber.toUpperCase();
  }

  return `${countryCode}${cleanVat}`;
};

// Erstellt eine Übersicht aller PLZ-Formate für Debugging
export const getPostalCodeFormats = () => {
  return countries.map((country) => ({
    code: country.countryCode,
    name: country.countryName ?? country.countryNameLocal,
    mask: country.postalCode?.mask,
    placeholder: country.postalCode?.placeholder,
    hasRegex: !!country.postalCode?.regex
  }));
};

// Erstellt eine Übersicht aller Telefon-Formate für Debugging
export const getPhoneFormats = () => {
  return countries.map((country) => ({
    code: country.countryCode,
    name: country.countryName ?? country.countryNameLocal,
    phoneCode: country.phoneCode,
    mask: country.phoneFormat?.mask,
    placeholder: country.phoneFormat?.placeholder
  }));
};

// Erstellt eine Übersicht aller VAT-Formate für Debugging
export const getVatFormats = () => {
  return countries
    .filter((country) => country.vatFormat)
    .map((country) => ({
      code: country.countryCode,
      name: country.countryName ?? country.countryNameLocal,
      mask: country.vatFormat?.mask,
      placeholder: country.vatFormat?.placeholder,
      example: country.vatFormat?.example,
      hasRegex: !!country.vatFormat?.regex
    }));
};
